import './index.less';
import {
  Image,
  Modal
} from 'antd';
import { ControlBar, Player } from "video-react";
import "video-react/dist/video-react.css";
import "./stylesV.css";
import * as React from 'react';
//import { Image } from 'antd';
import { inject, observer } from 'mobx-react';
import AuthenticationStore from '../../stores/authenticationStore';
import Stores from '../../stores/storeIdentifier';
import Slide11 from './../../images/swi/jbf_Banner2.png';
import LoginForm from '../../components/Controls/Forms/Custom/loginForm';
import SessionStore from '../../stores/sessionStore';
import { Progress as Progress2 } from '@ant-design/plots';
import { L } from '../../lib/abpUtility';
import { Button, Card, Col, Divider, Drawer, Form, notification, Progress, Row, } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import AccountStore from '../../stores/accountStore';
//import { GetCurrentLoginInformations } from '../../services/session/dto/getCurrentLoginInformations';
import DashboardView from '../../components/Controls/Views/dashboardView';
import IconImage from './../../images/swi/logoIcon.png';

import AAP from './../../images/ftb/banner.png';
import Titlw from './../../images/ftb/title.png';
import MeetTheTeam from './../../images/ftb/team.png';
import Resouces from './../../images/ftb/resources.png';

import More1 from './../../images/ftb/cateringHeader.png';
import More2 from './../../images/ftb/restaurantHeader.png';


import Team1 from './../../images/ftb/team1.png';
import Team2 from './../../images/ftb/team5.png';
import Team3 from './../../images/ftb/team3.png';
import Team4 from './../../images/ftb/team4.png';

import Slide1 from './../../images/swi/banner.png';
import Slide2 from './../../images/swi/banner2.png';
import Slide3 from './../../images/swi/banner3.png';
import Slide4 from './../../images/swi/banner4.png';
import PeoplePeview from './../../images/swi/PeoplePeview.png';

import EmpowerImage from './../../images/swi/History.png';
import PosterImage from './../../images/swi/coverPhoto.png';
import Slide6 from './../../images/swi/swiDemo.mp4';
import InOffice from './../../images/swi/InOffice.png';
import InField from './../../images/swi/InField.png';
import Portals from './../../images/swi/Portals.png';
import Dashboards from './../../images/swi/reports.png';

import Vendors from './../../images/swi/Vendors.png';
import OpenItems from './../../images/swi/OpenItems.png';
import ReportView from './../../images/swi/ReportView.png';
import VideoCover from './../../images/swi/VideoCover.png';

import Fleet from './../../images/swi/Fleet.png';
import Retail from './../../images/swi/Retail.png';
import Healthcare from './../../images/swi/Healthcare.png';
import Legal from './../../images/swi/Legal.png';
import FieldServices from './../../images/swi/FieldServices.png';
import IT from './../../images/swi/IT.png';
import Warehousing from './../../images/swi/Warehousing.png';
import Property from './../../images/swi/Property.png';
import Education from './../../images/swi/Education.png';
import Templates from './../../images/swi/Templates.png';


import HRChart from './../../images/swi/HRChart.png';
import Audit from './../../images/swi/Audit.png';

//import EngageImage from './../../images/swi/banner4.png';
//import InformImage from './../../images/swi/banner4.png';

//import SortImage from './../../images/swi/banner4.png';
//import ExploreImage from './../../images/swi/banner4.png';
//import LearnImage from './../../images/swi/banner4.png';
//import DiscoverImage from './../../images/swi/banner4.png';











import Tenants from './../../images/swi/Tenants.png';
import TBTLA from './../../images/swi/tbtla.png';
import Partners from './../../images/swi/partners.png';

import Slide7 from './../../images/swi/l1.png';
import Slide8 from './../../images/swi/l2.png';
import Slide9 from './../../images/swi/l3.png';
import Slide10 from './../../images/swi/l4.png';


import CateringImg from './../../images/swi/poeple.png';
import RetailImg from './../../images/swi/Dashboards.png';
import RestaurantsImg from './../../images/swi/ops.png';

import { DashboardLayoutDto, DashboardRowDto, DashboardColumnDto } from '../../services/dashboard/dto/dashboardLayoutDto';
import { UpCircleOutlined, ContactsTwoTone, BuildTwoTone, DollarTwoTone, FileTextTwoTone, IdcardTwoTone, LockTwoTone, MessageTwoTone, ProjectTwoTone, ReconciliationTwoTone, ScheduleTwoTone, TagsTwoTone, AppstoreTwoTone, AudioTwoTone, ControlTwoTone, FlagTwoTone, LayoutTwoTone, AccountBookTwoTone, CarTwoTone, DashboardTwoTone, DatabaseTwoTone, FundTwoTone, PieChartTwoTone, RocketTwoTone, SmileTwoTone, } from '@ant-design/icons';
import ContactForm from '../../components/Controls/Forms/Custom/contactForm';
import { DashboardItemTypes } from '../../components/EntityConfigs/dashboardItemTypes';
import { EntityDto } from '../../services/dto/entityDto';
import LegalForm from '../../components/Controls/Forms/Custom/legalForm';
import { WebContentTypes } from '../../components/EntityConfigs/webContentTypes';

import { FormInstance } from 'antd/lib/form/Form';
import UserStore from '../../stores/userStore';
import ScheduleDemoForm from '../../components/Controls/Forms/Custom/scheduleDemoForm';
import MoreInfoDrawer from '../../components/Controls/Drawers/Custom/moreInfoDrawer';

import { Redirect } from 'react-router-dom';
import OurTeam from '../../components/Controls/Forms/Custom/ourTeam';
import Meta from 'antd/es/card/Meta';
import OurStory from '../../components/Controls/Forms/Custom/ourStory';
import TenantAvailabilityState from '../../services/account/dto/tenantAvailabilityState';
import { GetCurrentLoginInformations } from '../../services/session/dto/getCurrentLoginInformations';
//import TenantAvailabilityState from '../../services/account/dto/tenantAvailabilityState';

declare var abp: any;

export interface ILoginProps {
  authenticationStore: AuthenticationStore;
  history: any;
  location: any;
  accountStore?: AccountStore;
  sessionStore: SessionStore;
  userStore: UserStore;
}

export interface ILoginState {

  empower_DrawerVisible: boolean;
  engage_DrawerVisible: boolean;
  inform_DrawerVisible: boolean;

  sort_DrawerVisible: boolean;
  explore_DrawerVisible: boolean;
  learn_DrawerVisible: boolean;
  discover_DrawerVisible: boolean;

  video_DrawerVisible: boolean;
  currentForm: string;
  moreInfoType: number;
  team_modalVisible: boolean;
  demo_modalVisible: boolean;
  login_modalVisible: boolean;
  ourStory_ModalVisible: boolean;
  moreInfo_drawerVisible: boolean;
  contact_modalVisible: boolean;

  subDashboard_modalVisible: boolean;
  subDashboard_defaultImage: any;
  subDashboard_imageCarousel: any;
  subDashboard_titleText: any;
  subDashboard_bodyText: any;
  subDashboard_configuration: any;

  veryMobile: boolean;
  cardSize: string;
  currentTab: string;
  deleteDrawerVisible: boolean;
  createModalVisible: boolean;
  editModalVisible: boolean;
  maxResultCount: number;
  skipCount: number;
  userId: number;
  filter: string;
  cardHeight: string;
  formSize: number;
  searchSize: string;
  tableSize: string;
  collapseTitle: boolean;
  defaultProfileImage: string;
  loading: boolean;
  isMobile: boolean;
  legal_modalVisible: boolean;
  currentUserID: number;
  currentLoginName: string;
  currentLoginLastName: string;
  profileImageID: number;
  profileImageURL: string;
  currentUsername: string;
  currentEmailAddres: string;

  currentTenantName: string;
  primaryTenantColor: string;
  secondaryTenantColor: string;

  tenantImageID: number;
  tenantImageURL: string;
  tenantTitle: string;
  windowWidth: number;
  tenantSubscriptionStart: string;
  tenantSubscriptionEnd: string;
  tenantSubscriptionActive: boolean;
  softMenu: boolean;
  roles: string[];

  headerFontSize: string;
  bannerFontSize: string;

}

@inject(Stores.AuthenticationStore, Stores.SessionStore, Stores.AccountStore, Stores.UserStore)
@observer
class Login extends React.Component<ILoginProps, ILoginState> {

  contact_FormRef = React.createRef<FormInstance>();
  demo_FormRef = React.createRef<FormInstance>();

  state = {

    empower_DrawerVisible: false,
    engage_DrawerVisible: false,
    inform_DrawerVisible: false,
    video_DrawerVisible: false,
    sort_DrawerVisible: false,
    explore_DrawerVisible: false,
    learn_DrawerVisible: false,
    discover_DrawerVisible: false,

    ourStory_ModalVisible: false,

    subDashboard_modalVisible: false,
    subDashboard_defaultImage: '',
    subDashboard_imageCarousel: [],
    subDashboard_titleText: '',
    subDashboard_bodyText: '',
    subDashboard_configuration: [],

    currentForm: 'SWI',
    moreInfoType: 0,
    windowWidth: 0,
    moreInfo_drawerVisible: false,
    team_modalVisible: false,
    login_modalVisible: false,
    contact_modalVisible: false,
    demo_modalVisible: false,
    cardSize: '',
    isMobile: false,
    softMenu: false,
    collapseTitle: false,
    deleteDrawerVisible: false,
    createModalVisible: false,
    editModalVisible: false,
    cardHeight: '',
    loading: false,
    defaultProfileImage: '',
    maxResultCount: 10,
    skipCount: 0,
    userId: 0,
    filter: '',
    dataTableText: L('Click the Create button to add data!'),
    formSize: 0,
    searchSize: '',
    tableSize: '',
    legal_modalVisible: false,
    currentTab: 'swilab',

    roles: [],

    veryMobile: true,

    currentUserID: 0,
    currentLoginName: 'Modern Business Software',
    currentLoginLastName: '',
    profileImageID: 0,
    profileImageURL: '',
    currentUsername: '',
    currentEmailAddres: '',

    currentTenantName: 'Swilab',
    primaryTenantColor: '#303238',
    secondaryTenantColor: '#375488',

    tenantImageID: 0,
    tenantImageURL: '',
    tenantTitle: '',

    tenantSubscriptionStart: '',
    tenantSubscriptionEnd: '',
    tenantSubscriptionActive: false,

    headerFontSize: '3.2em',
    bannerFontSize: '2.6em',


  };

  async componentDidMount() {

    this.setState({
      loading: true,
      windowWidth: window.innerWidth,
    });

    let requireRestart = false;
    var currentLoginInfo: GetCurrentLoginInformations = this.props.sessionStore.currentLogin;

    try {
      console.warn('Set Tenant: ' + currentLoginInfo.tenant.id)
    }
    catch
    {
      requireRestart = true;
    }

    let tenancyName = 'Default';
    const { loginModel } = this.props.authenticationStore!;

    if (!tenancyName) {

      abp.multiTenancy.setTenantIdCookie(undefined);
      window.location.href = '/';
      return;

    }
    else {

      await this.props.accountStore!.isTenantAvailable(tenancyName);
      const { tenant } = this.props.accountStore!;


      switch (tenant.state) {
        case TenantAvailabilityState.Available:
          await abp.multiTenancy.setTenantIdCookie(tenant.tenantId);
          loginModel.tenancyName = tenancyName;
          loginModel.toggleShowModal();
          window.location.href = '/';
          break;

        case TenantAvailabilityState.InActive:
          Modal.error({ title: L('Error'), content: L('TenantIsNotActive') });
          break;

        case TenantAvailabilityState.NotFound:
          Modal.error({ title: L('Error'), content: L('ThereIsNoTenantDefinedWithName{0}', tenancyName) });
          break;
      }

    }

    if (requireRestart === true) {
      window.location.href = '/';
      return;
    }

    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)

    this.setState({
      loading: false
    });

    if (window.innerWidth >= 550) {
      this.setState({
        formSize: 500,
        headerFontSize: '3.2em',
        bannerFontSize: '2.6em',
        cardSize: (window.innerWidth * 0.85).toString() + 'px',
      });
    }
    else {
      this.setState({
        formSize: (window.innerWidth * 0.88),
        headerFontSize: '2.6em',
        bannerFontSize: '2.2em',
        cardSize: (window.innerWidth * 0.80).toString() + 'px',
      });
    }

    if (window.innerWidth >= 710) {
      this.setState({
        isMobile: false
      });
    }
    else {
      this.setState({
        isMobile: true
      });
    }

    if (window.innerWidth >= 580) {
      this.setState({
        veryMobile: false
      });
    }
    else {
      this.setState({
        veryMobile: true
      });
    }
  }

  contact_handleUpdate = (values: any) => {
    this.props.accountStore!.contact(values);

    notification.open({
      message: L('Confirmation'),
      description:
        L('Thanks! We will reach out soon.')
    });

    this.contact_FormRef?.current?.resetFields();

  };

  demo_handleUpdate = (values: any) => {
    this.props.accountStore!.scheduleDemo(values);

    notification.open({
      message: L('Confirmation'),
      description:
        L('Thanks! We will reach out soon to confirm your demo.')
    });

    this.demo_FormRef?.current?.resetFields();

  };

  demoContact_handleCancel = () => {
    this.demo_FormRef?.current?.resetFields();
    this.contact_FormRef?.current?.resetFields();

    this.setState({
      contact_modalVisible: false,
      demo_modalVisible: false
    })

  };

  handleScroll = () => {
    const position = window.pageYOffset;
    if (position >= 50) {
      this.setState({ softMenu: true });
    }
    else {
      this.setState({ softMenu: false });
    }
  };

  handleResize = () => {


    this.setState({ windowWidth: window.innerWidth });

    if (window.innerWidth >= 550) {
      this.setState({
        formSize: 500,
        headerFontSize: '3.2em',
        bannerFontSize: '2.6em',
        cardSize: (window.innerWidth * 0.85).toString() + 'px',
      });
    }
    else {
      this.setState({
        formSize: (window.innerWidth * 0.88),
        headerFontSize: '2.6em',
        bannerFontSize: '2.2em',
        cardSize: (window.innerWidth * 0.80).toString() + 'px',
      });
    }

    if (window.innerWidth >= 710) {
      this.setState({
        isMobile: false
      });
    }
    else {
      this.setState({
        isMobile: true
      });
    }

    if (window.innerWidth >= 580) {
      this.setState({
        veryMobile: false
      });
    }
    else {
      this.setState({
        veryMobile: true
      });
    }
  }


  async legal_createOrUpdateModalOpen(entityDto: EntityDto) {

    this.legal_Modal();

  }

  async subDrawer_OpenModal(config: any) {



  }

  legal_Modal = () => {
    this.setState({
      legal_modalVisible: !this.state.legal_modalVisible,
    });
  };

  //------------------------------------------------------------







  //------------------------------------------------------------

  public render() {
    let { from } = this.props.location.state || { from: '/' };
    if (this.props.authenticationStore!.isAuthenticated) return <Redirect to={from} />;


    const imageCarConfig2V: any = {
      defaultImage: AAP,
      imageList: [AAP],
      preview: false

    }


    const imageCarConfig2T: any = {
      defaultImage: MeetTheTeam,
      imageList: [MeetTheTeam],
      preview: false

    }

    const imageCarConfig3T: any = {
      defaultImage: Resouces,
      imageList: [Resouces],
      preview: false

    }

    const imageCarConfig: any = {
      defaultImage: Slide1,
      imageList: [Slide1, Slide2, Slide3, Slide4,],
      preview: false

    }

    const imageCarConfig2: any = {
      defaultImage: Slide11,
      imageList: [Slide11],
      preview: false

    }

    const videoCardCnfig: any = {
      url: Slide6,
      poster: PosterImage
    }

    const dashboardLayout: DashboardLayoutDto<DashboardRowDto<DashboardColumnDto>> = {
      totalRows: 6,
      rows: [
        {
          totalColumns: 1,
          columns: [
            {
              type: DashboardItemTypes.ImageCarousel,
              title: '',
              dataModel: imageCarConfig
            },
          ]
        },

        {
          totalColumns: 4,
          columns: [
            {
              type: DashboardItemTypes.WebContent,
              title: L('Sort'),
              dataModel: {
                webContentType: WebContentTypes.imageHeader,
                image: Slide10,
                header: L('By Industry'),
                content: L('Built to handle multiple business types and vertices.'),
                buttonText: L('View'),
                action: () => this.setState({ sort_DrawerVisible: true }),

              }
            },
            {
              type: DashboardItemTypes.WebContent,
              title: L('Explore'),
              dataModel: {
                webContentType: WebContentTypes.imageHeader,
                image: Slide7,
                header: L('By Department'),
                content: L('Capable of unifying every department in one place.'),
                buttonText: L('View'),
                action: () => this.setState({ explore_DrawerVisible: true }),

              }
            },
            {
              type: DashboardItemTypes.WebContent,
              title: L('Learn'),
              dataModel: {
                webContentType: WebContentTypes.imageHeader,
                image: Slide8,
                header: L('Where we Fit'),
                content: L('Designed to support your brand and company style.'),
                buttonText: L('View'),
                action: () => this.setState({ learn_DrawerVisible: true }),

              }
            },
            {
              type: DashboardItemTypes.WebContent,
              title: L('Discover'),
              dataModel: {
                webContentType: WebContentTypes.imageHeader,
                image: Slide9,
                header: L('Feature Breakdown'),
                content: L('See a list of powerful key features included with Swilab.'),
                buttonText: L('View'),
                action: () => this.setState({ discover_DrawerVisible: true }),

              }
            },
          ]
        },
        {
          totalColumns: 1,
          columns: [
            {
              type: DashboardItemTypes.ImageCarousel,
              title: L('Customer Highlight'),
              dataModel: imageCarConfig2
            },]
        },
        {
          totalColumns: 3,
          columns: [
            {
              type: DashboardItemTypes.WebContent,
              title: L('Automate'),
              dataModel: {
                webContentType: WebContentTypes.imageHeader,
                image: RestaurantsImg,
                header: L('Business Tasks'),
                content: L('Design custom workflows that include automations and approvals.'),
                buttonText: L('Learn More'),
                action: () => this.setState({ empower_DrawerVisible: true }),

              }
            },
            {
              type: DashboardItemTypes.WebContent,
              title: L('Engage'),
              dataModel: {
                webContentType: WebContentTypes.imageHeader,
                image: CateringImg,
                header: L('Your Customers'),
                content: L('Provide access to data and services to customers via web portals.'),
                buttonText: L('Learn More'),
                action: () => this.setState({ engage_DrawerVisible: true }),

              }
            },
            {
              type: DashboardItemTypes.WebContent,
              title: L('Inform'),
              dataModel: {
                webContentType: WebContentTypes.imageHeader,
                image: RetailImg,
                header: L('Decision Makers'),
                content: L('Display information across departments in one place in real time.'),
                buttonText: L('Learn More'),
                action: () => this.setState({ inform_DrawerVisible: true }),

              }
            },
          ]
        },



        {
          totalColumns: 1,
          columns: [
            {
              type: DashboardItemTypes.VideoCard,
              title: '',
              dataModel: videoCardCnfig
            },
          ]
        },
        {
          totalColumns: 2,
          columns: [
            {
              type: DashboardItemTypes.WebContent,
              title: L('Partners'),
              dataModel: {
                webContentType: WebContentTypes.imageHeader,
                image: Partners,
                header: L('Powering Systems'),
                content: L('Swilab provides a robust platform capable of being integrated with partnering systems to help existing business platforms grow.'),
                buttonText: 'See how it works',
                action: () => this.setState({ video_DrawerVisible: true }),

              }
            },
            {
              type: DashboardItemTypes.WebContent,
              title: L('Community'),
              dataModel: {
                webContentType: WebContentTypes.imageHeader,
                image: TBTLA,
                header: L('Your Customers'),
                content: L('We support local nonprofit organizations providing Swilab, which helps manage memberships, events payments, and more.'),
                buttonText: 'What is TBTLA?',
                action: () => window.open('https://tbtla.org', "_blank"),

              }
            },

          ]
        },


      ]
    };


    const dashboardLayoutFTB: DashboardLayoutDto<DashboardRowDto<DashboardColumnDto>> = {
      totalRows: 5,
      rows: [
        {
          totalColumns: 1,
          columns: [
            {
              type: DashboardItemTypes.ImageCarousel,
              title: '',
              dataModel: imageCarConfig2V
            },
          ]
        },
        {
          totalColumns: 1,
          columns: [
            {
              type: DashboardItemTypes.ImageCarousel,
              title: '',
              dataModel: imageCarConfig2T
            },
          ]
        },

        {
          totalColumns: 4,
          columns: [
            {
              type: DashboardItemTypes.WebContent,
              title: '',
              dataModel: {
                webContentType: WebContentTypes.imageHeader,
                image: Team1,
                header: L('Jane Doe'),
                content: L('Director of Agency Relations'),
                buttonText: L('Send Message'),
                action: () => '',

              }
            },
            {
              type: DashboardItemTypes.WebContent,
              title: '',
              dataModel: {
                webContentType: WebContentTypes.imageHeader,
                image: Team2,
                header: L('Jon Doe'),
                content: L('Agency Relations Specialist'),
                buttonText: L('Send Message'),
                action: () => '',

              }
            },
            {
              type: DashboardItemTypes.WebContent,
              title: '',
              dataModel: {
                webContentType: WebContentTypes.imageHeader,
                image: Team3,
                header: L('Jane Doe'),
                content: L('Agency Relations Manager'),
                buttonText: L('Send Message'),
                action: () => '',

              }
            },
            {
              type: DashboardItemTypes.WebContent,
              title: '',
              dataModel: {
                webContentType: WebContentTypes.imageHeader,
                image: Team4,
                header: L('Jane Doe'),
                content: L('Partnerships Coordinator'),
                buttonText: L('Send Message'),
                action: () => '',

              }
            },
          ]
        },



        {
          totalColumns: 1,
          columns: [
            {
              type: DashboardItemTypes.ImageCarousel,
              title: '',
              dataModel: imageCarConfig3T
            },
          ]
        },


        {
          totalColumns: 2,
          columns: [

            {
              type: DashboardItemTypes.WebContent,
              title: '',
              dataModel: {
                webContentType: WebContentTypes.imageHeader,
                image: More1,
                header: 'Agency Express',
                content: 'Place an online order and stock your shelves.',
                buttonText: 'Place Order',
                action: () => '',

              }
            },
            {
              type: DashboardItemTypes.WebContent,
              title: '',
              dataModel: {
                webContentType: WebContentTypes.imageHeader,
                image: More2,
                header: 'Seed Connect',
                content: 'Find excess product from local suppliers in your area.',
                buttonText: 'Get Started',
                action: () => '',

              }
            },
          ]
        },


      ]
    };

    //const antIcon = <LoadingOutlined style={{ fontSize: 20, color: this.state.primaryTenantColor }} spin />;

    const headerConfig = {
      percent: 1,
      color: [this.state.secondaryTenantColor, this.state.primaryTenantColor],
    };

    return (


      <div>


        {this.state.currentForm === 'SWI' && this.state.loading === false ?

          <div className="font-face-gm">

            <div>
              <Card bordered={false}>
                <div>


                  <Form>
                    <div style={{ margin: 'auto', maxWidth: '900px' }}>

                      <div style={{ margin: 'auto', maxWidth: '890px' }} >
                        {this.state.windowWidth >= 550 ?
                          (

                            <div>


                              <div>

                                <PageHeader
                                  title={<div className="font-face-gm"><div
                                    style={{ marginBottom: '0px', textAlign: 'left', fontSize: '2em' }}>{this.state.currentTenantName}</div>
                                    <div style={{ marginTop: '-10px', opacity: '0.5', fontSize: '1em' }}>{this.state.currentLoginName}</div></div>}
                                  className="site-page-header"
                                  style={{ textAlign: 'left', marginBottom: '0px', marginTop: '15px' }}
                                  avatar={{ size: 'large', src: IconImage }}
                                />


                                <div>

                                  {this.state.softMenu === true ?
                                    (<div>
                                      <div style={{
                                        float: 'right', position: 'fixed',
                                        top: 10, right: 25, zIndex: 99,
                                      }}>

                                        <Button
                                          disabled={this.state.loading}
                                          className="font-face-gm" onClick={() => window.scrollTo({ top: 10, behavior: "smooth" })}
                                          style={{ minWidth: '75px', height: '27px', fontSize: '0.8em', backgroundColor: 'transparent' }}
                                          type="default">
                                          <UpCircleOutlined />{L('Top')}
                                        </Button>


                                      </div>

                                    </div>) :


                                    <div>




                                      <div style={{ float: 'right', position: 'fixed', top: 10, right: 25, zIndex: 99, }}>

                                        <Button disabled={this.state.loading}
                                          onClick={() => this.setState({ login_modalVisible: true })}
                                          className="font-face-gm" style={{
                                            minWidth: '85px', height: '30px', fontSize: '1em',
                                            background: this.state.secondaryTenantColor, borderColor: this.state.secondaryTenantColor
                                          }}
                                          type="primary">
                                          {L('Login')}
                                        </Button>

                                      </div>

                                      <div style={{ float: 'right', position: 'fixed', top: 10, right: 120, zIndex: 101, }}>

                                        <Button disabled={this.state.loading}
                                          onClick={() => this.setState({ contact_modalVisible: true })}
                                          className="font-face-gm" style={{
                                            minWidth: '85px', height: '30px',
                                            fontSize: '1em', backgroundColor: 'transparent'
                                          }} type="default">
                                          {L('Contact')}
                                        </Button>

                                      </div>

                                    </div>}

                                </div>


                              </div>

                            </div>
                          ) : (

                            <div>


                              <div style={{ height: '10px', margin: 'auto', textAlign: 'center' }}></div>

                              <PageHeader
                                title={
                                  <div className="font-face-gm"><div
                                    style={{ marginBottom: '0px', fontSize: '1em' }}>{this.state.currentTenantName}</div>
                                    <div style={{ marginTop: '-15px', opacity: '0.5', fontSize: '0.7em' }}>{this.state.currentLoginName}</div></div>}
                                className="site-page-header"
                                style={{ margin: 'auto', marginLeft: '5%' }}



                                avatar={{ size: 'large', src: IconImage }}
                              />

                              <div>

                                {this.state.softMenu === true ?
                                  (<div>
                                    <div style={{
                                      float: 'right', position: 'fixed',
                                      top: 10, right: 25, zIndex: 99,
                                    }}>

                                      <Button
                                        disabled={this.state.loading}
                                        className="font-face-gm" onClick={() => window.scrollTo({ top: 10, behavior: "smooth" })}
                                        style={{ minWidth: '75px', height: '27px', fontSize: '0.8em', backgroundColor: 'transparent' }}
                                        type="default">
                                        <UpCircleOutlined />{L('Top')}
                                      </Button>


                                    </div>

                                  </div>) :


                                  <div>

                                    <div style={{ float: 'right', position: 'fixed', top: 10, right: 25, zIndex: 99, }}>
                                      <Button
                                        disabled={this.state.loading}
                                        onClick={() => this.setState({ login_modalVisible: true })}
                                        className="font-face-gm" style={{ minWidth: '75px', height: '30px', fontSize: '1em', backgroundColor: 'transparent' }} type="default">
                                        {L('Login')}
                                      </Button>
                                    </div>
                                    <div style={{ float: 'right', position: 'fixed', top: 45, right: 25, zIndex: 99, }}>

                                      <Button disabled={this.state.loading}
                                        onClick={() => this.setState({ contact_modalVisible: true })}
                                        className="font-face-gm" style={{ width: '75px', height: '30px', fontSize: '0.85em', backgroundColor: 'transparent' }} type="default">
                                        {L('Contact')}
                                      </Button>

                                    </div>
                                  </div>}

                              </div>


                            </div>
                          )}

                      </div>


                    </div>
                  </Form>




                  <br />
                  <div style={{ margin: 'auto', marginTop: '-15px', maxWidth: '900px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.secondaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </div>

                  <br />
                  <div style={{ margin: 'auto', marginTop: '-15px', maxWidth: '900px' }}>

                    <DashboardView
                      primaryColor={this.state.primaryTenantColor}
                      secondaryColor={this.state.secondaryTenantColor}
                      dashboardDto={dashboardLayout}
                    />
                  </div>

                </div>

                <div>

                  <LoginForm
                    authenticationStore={this.props.authenticationStore}
                    location={this.props.location}
                    visible={this.state.login_modalVisible}
                    primaryColor={this.state.primaryTenantColor}
                    secondaryColor={this.state.secondaryTenantColor}
                    isMobile={this.state.isMobile}
                    onCancel={() => this.setState({
                      login_modalVisible: false,
                    })}
                    onLogin={() => this.setState({
                      login_modalVisible: false,
                    })}
                  />


                  <OurTeam
                    location={this.props.location}
                    visible={this.state.team_modalVisible}
                    primaryColor={this.state.primaryTenantColor}
                    secondaryColor={this.state.secondaryTenantColor}
                    isMobile={this.state.isMobile}
                    onCancel={() => this.setState({
                      team_modalVisible: false,
                    })}
                    onLogin={() => this.setState({
                      team_modalVisible: false,
                    })}
                  />

                  <OurStory
                    location={this.props.location}
                    visible={this.state.ourStory_ModalVisible}
                    primaryColor={this.state.primaryTenantColor}
                    secondaryColor={this.state.secondaryTenantColor}
                    isMobile={this.state.isMobile}
                    onCancel={() => this.setState({
                      ourStory_ModalVisible: false,
                    })}
                    onLogin={() => this.setState({
                      ourStory_ModalVisible: false,
                    })}
                  />

                  <ContactForm
                    formRef={this.contact_FormRef}
                    authenticationStore={this.props.authenticationStore}
                    location={this.props.location}
                    visible={this.state.contact_modalVisible}
                    primaryColor={this.state.primaryTenantColor}
                    secondaryColor={this.state.secondaryTenantColor}
                    isMobile={this.state.isMobile}
                    onCancel={this.demoContact_handleCancel}
                    onLogin={this.contact_handleUpdate}
                  />

                  <ScheduleDemoForm
                    formRef={this.demo_FormRef}
                    authenticationStore={this.props.authenticationStore}
                    location={this.props.location}
                    visible={this.state.demo_modalVisible}
                    primaryColor={this.state.primaryTenantColor}
                    secondaryColor={this.state.secondaryTenantColor}
                    isMobile={this.state.isMobile}
                    onCancel={this.demoContact_handleCancel}
                    onLogin={this.demo_handleUpdate}
                  />

                </div>

              </Card>

              <div style={{ margin: 'auto', maxWidth: '900px', marginBottom: '20px', width: '100%' }}>

                <div style={{ height: '150px', margin: 'auto', textAlign: 'center' }}>
                  <br />


                  <Form className="" >
                    <Row style={{ marginTop: '0% ', textAlign: 'center' }}>

                      <Col className="font-face-gm" style={{ fontSize: '1em' }} span={22} offset={1}>


                        <Button className="font-face-gm"
                          onClick={() => this.legal_createOrUpdateModalOpen({ id: 0 })}
                          shape="round" size="small" type="link" style={{ color: '#433f36', fontSize: '20px' }} >
                          {L('Legal')}
                        </Button>|

                        <Button className="font-face-gm"
                          onClick={() => window.open('https://www.linkedin.com/company/swilab/', "_blank")}
                          shape="round" size="small" type="link" style={{ color: '#433f36', fontSize: '20px' }} >
                          {L('Social')}
                        </Button>


                      </Col>

                    </Row>
                    <Row style={{ marginTop: '0% ', textAlign: 'center' }}>

                      <Col className="font-face-gm" style={{ fontSize: '0.9em' }} span={22} offset={1}>
                        {L('Copyright - Swilab, LLC - 2023 - All Rights Reserved.')}
                      </Col>

                    </Row>
                  </Form>

                </div>

              </div>

            </div>

            <MoreInfoDrawer
              visible={this.state.moreInfo_drawerVisible}
              primaryColor={this.state.primaryTenantColor}
              secondaryColor={this.state.secondaryTenantColor}
              onCancel={() => this.setState({ moreInfo_drawerVisible: false })}
              infoType={this.state.moreInfoType}
            />

            <LegalForm
              visible={this.state.legal_modalVisible}
              primaryColor={this.state.primaryTenantColor}
              secondaryColor={this.state.secondaryTenantColor}
              isMobile={this.state.isMobile}
              onCancel={() => this.setState({ legal_modalVisible: false })} />


            <div>

              {this.state.isMobile === true ?

                <Drawer
                  closable={this.state.isMobile === true ? true : false}
                  onClose={() => this.setState({ empower_DrawerVisible: false })}
                  visible={this.state.empower_DrawerVisible}
                  footer={null}
                  width={this.state.isMobile === true ? (window.innerWidth * 0.9) : 420}
                  title={null}  >
                  <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2em', marginBottom: '0px' }} >
                    {L('Business Operations')}
                  </Divider>
                  <Row style={{ marginBottom: '20px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.primaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </Row>


                  <Image src={EmpowerImage} style={{ margin: 'auto' }} preview={false} />


                  <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>
                    <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                      style={{}}>
                      <Meta className="font-face-gm"
                        title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Workflow and Automation'}</div>}
                        description={L('Swilab offers a simple way to manage custom workflows, approvals, and automations needed to successfully manage operations from anywhere.')} />

                    </Card>





                    <br />


                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>


                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <Image width={80} src={InOffice} preview={false} /></div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'In the Office'}</div>}
                                description={'Get a handle on day-to-day tasks and plan for future business with robust desktop features.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'In the Office'}</div>}
                            description={'Get a handle on day-to-day tasks and plan for future business with robust desktop features.'} />
                        </div>
                      }
                    </Card>


                    <br />
                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>
                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <Image width={80} src={InField} preview={false} /></div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'In the Field'}</div>}
                                description={'Work from anywhere with intuitive mobile design for tablets and phones. All desktop features are supported by mobile devices.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'In the Field'}</div>}
                            description={'Work from anywhere with intuitive mobile design for tablets and phones. All desktop features are supported by mobile devices.'} />
                        </div>
                      }

                    </Card>





                  </Card>

                </Drawer>
                :
                <Modal
                  closable={this.state.isMobile}
                  visible={this.state.empower_DrawerVisible}
                  cancelText={L('Cancel')}
                  footer={null}
                  width={730}
                  onCancel={() => this.setState({ empower_DrawerVisible: false })}
                  title={null}>
                  <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                    {L('Business Operations')}
                  </Divider>
                  <Row style={{ marginBottom: '0px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.primaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </Row>


                  <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>

                    <Card hoverable={true} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                      style={{}}><div style={{ float: 'left', marginRight: '5px' }}>
                        <Image src={EmpowerImage} preview={false} /></div>
                      <div>


                        <Meta className="font-face-gm"
                          title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Workflow and Automation'}</div>}
                          description={L('Swilab offers a simple way to manage custom workflows, approvals, and automations needed to successfully manage operations from anywhere.')} />
                      </div>
                    </Card>


                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <Image width={125} src={InOffice} preview={false} />

                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'In the Office'}</div>}
                          description={'Get a handle on day-to-day tasks and plan for future business with robust desktop features.'} />
                      </div>


                    </Card>

                    <br />
                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <Image width={125} src={InField} preview={false} />

                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'In the Field'}</div>}
                          description={'Work from anywhere with intuitive mobile design for tablets and phones. All desktop features are supported by mobile devices.'} />
                      </div>


                    </Card>



                  </Card>


                </Modal>
              }

            </div>

            <div>
              {this.state.isMobile === true ?

                <Drawer
                  closable={this.state.isMobile === true ? true : false}
                  onClose={() => this.setState({ engage_DrawerVisible: false })}
                  visible={this.state.engage_DrawerVisible}
                  footer={null}
                  width={this.state.isMobile === true ? (window.innerWidth * 0.9) : 420}
                  title={null}  >
                  <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2em', marginBottom: '0px' }} >
                    {L('More than CRM')}
                  </Divider>
                  <Row style={{ marginBottom: '20px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.primaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </Row>


                  <Image src={PeoplePeview} style={{ margin: 'auto' }} preview={false} />


                  <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>
                    <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                      style={{}}>
                      <Meta className="font-face-gm"
                        title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'a Powerful Engine'}</div>}
                        description={L('Swilab is a robust platform capable of advanced operations, and built to enable future growth/improvements by a standardized corporate development team.')} />

                    </Card>





                    <br />


                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>


                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <Image width={80} src={Vendors} preview={false} /></div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Customer Portals'}</div>}
                                description={'Design beautiful customer portals to display information, capture customer data, and provide customer login portals.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Customer Portals'}</div>}
                            description={'Design beautiful customer portals to display information, capture customer data, and provide customer login portals.'} />
                        </div>
                      }
                    </Card>


                    <br />
                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>
                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <Image width={80} src={Portals} preview={false} /></div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Vendor Management'}</div>}
                                description={'Manage supply chain internally, and engage external vendors by providing access to information just like employees and customers via web portal.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Vendor Management'}</div>}
                            description={'Manage supply chain internally, and engage external vendors by providing access to information just like employees and customers via web portal.'} />
                        </div>
                      }

                    </Card>





                  </Card>

                </Drawer>
                :
                <Modal
                  closable={this.state.isMobile}
                  visible={this.state.engage_DrawerVisible}
                  cancelText={L('Cancel')}
                  footer={null}
                  width={730}
                  onCancel={() => this.setState({ engage_DrawerVisible: false })}
                  title={null}>
                  <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                    {L('More than CRM')}
                  </Divider>
                  <Row style={{ marginBottom: '0px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.primaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </Row>


                  <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>

                    <Card hoverable={true} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                      style={{}}><div style={{ float: 'left', marginRight: '5px' }}>
                        <Image src={PeoplePeview} preview={false} /></div>
                      <div>


                        <Meta className="font-face-gm"
                          title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'a POwerful Engine'}</div>}
                          description={L('Swilab is a robust platform capable of advanced operations, and built to enable future growth/improvements by a standardized corporate development team.')} />
                      </div>
                    </Card>


                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <Image width={125} src={Vendors} preview={false} />

                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Customer Portals'}</div>}
                          description={'Design beautiful customer portals to display information, capture customer data, and provide customer login portals.'} />
                      </div>


                    </Card>

                    <br />
                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <Image width={125} src={Portals} preview={false} />

                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Vendor Management'}</div>}
                          description={'Manage supply chain internally, and engage external vendors by providing access to information just like employees and customers via web portal'} />
                      </div>


                    </Card>


                  </Card>


                </Modal>
              }

            </div>

            <div>
              {this.state.isMobile === true ?

                <Drawer
                  closable={this.state.isMobile === true ? true : false}
                  onClose={() => this.setState({ inform_DrawerVisible: false })}
                  visible={this.state.inform_DrawerVisible}
                  footer={null}
                  width={this.state.isMobile === true ? (window.innerWidth * 0.9) : 420}
                  title={null}  >
                  <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2em', marginBottom: '0px' }} >
                    {L('Real-Time Data')}
                  </Divider>
                  <Row style={{ marginBottom: '20px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.primaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </Row>


                  <Image src={Dashboards} style={{ margin: 'auto' }} preview={false} />


                  <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>
                    <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                      style={{}}>
                      <Meta className="font-face-gm"
                        title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Intuitive Design'}</div>}
                        description={L('Cutting-Edge design practices allow traditionally technical and complex activities to be performed simply, and promote adoption even by less technical customers/staff.')} />

                    </Card>





                    <br />


                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>


                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <Image width={80} src={HRChart} preview={false} /></div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Leadership Dashboards'}</div>}
                                description={'Company access for up to 10 attendees to all Quarterly meetings, seminars, and social networking events.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Audit-Ready Reports'}</div>}
                            description={'Company access for up to 10 attendees to all Quarterly meetings, seminars, and social networking events.'} />
                        </div>
                      }
                    </Card>


                    <br />
                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>
                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <Image width={80} src={Audit} preview={false} /></div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'In the Field '}</div>}
                                description={'Company access for up to 10 attendees to all Quarterly meetings, seminars, and social networking events.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'In the Field '}</div>}
                            description={'Company access for up to 10 attendees to all Quarterly meetings, seminars, and social networking events.'} />
                        </div>
                      }

                    </Card>





                  </Card>

                </Drawer>
                :
                <Modal
                  closable={this.state.isMobile}
                  visible={this.state.inform_DrawerVisible}
                  cancelText={L('Cancel')}
                  footer={null}
                  width={730}
                  onCancel={() => this.setState({ inform_DrawerVisible: false })}
                  title={null}>
                  <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                    {L('Real-Time Data')}
                  </Divider>
                  <Row style={{ marginBottom: '0px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.primaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </Row>


                  <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>

                    <Card hoverable={true} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                      style={{}}><div style={{ float: 'left', marginRight: '5px' }}>
                        <Image src={Dashboards} preview={false} /></div>
                      <div>


                        <Meta className="font-face-gm"
                          title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Intuitive Design'}</div>}
                          description={L('Cutting-Edge design practices allow traditionally technical and complex activities to be performed simply, and promote adoption even by less technical customers/staff.')} />
                      </div>
                    </Card>


                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <Image width={125} src={HRChart} preview={false} />

                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Leadership Dashboards'}</div>}
                          description={'Company access for up to 10 attendees to all Quarterly meetings, seminars, and social networking events.'} />
                      </div>


                    </Card>

                    <br />
                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <Image width={125} src={Audit} preview={false} />

                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Audit-Ready Reports'}</div>}
                          description={'Company access for up to 10 attendees to all Quarterly meetings, seminars, and social networking events.'} />
                      </div>


                    </Card>



                  </Card>


                </Modal>
              }

            </div>

            <div>
              {this.state.isMobile === true ?

                <Drawer
                  closable={this.state.isMobile === true ? true : false}
                  onClose={() => this.setState({ sort_DrawerVisible: false })}
                  visible={this.state.sort_DrawerVisible}
                  footer={null}
                  width={this.state.isMobile === true ? (window.innerWidth * 0.9) : 420}
                  title={null}  >
                  <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2em', marginBottom: '0px' }} >
                    {L('Common Industries')}
                  </Divider>
                  <Row style={{ marginBottom: '20px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.primaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </Row>


                  <Image src={Templates} style={{ margin: 'auto' }} preview={false} />


                  <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>
                    <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                      style={{}}>
                      <Meta className="font-face-gm"
                        title={<div style={{ fontSize: '1.1em', height: '25px', }}>{L('Built for Multiple Verticles')}</div>}
                        description={L('Swilab has been designed to meet the requirements of different business types. The ability to easily customize for your industry means you can get going quickly in the following areas and more!')} />

                    </Card>









                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                      {this.state.veryMobile === false ?
                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <Image width={80} src={Fleet} preview={false} /></div>
                          <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Transportation')}</div>}
                            description={L('Manage fleets, and connect your staff, customers, and dispatch all in one place.')} />

                          </div></div></div>
                        :
                        <div>
                          <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Transportation')}</div>}
                            description={L('Manage fleets, and connect your staff, customers, and dispatch all in one place.')} />
                        </div>
                      }
                    </Card>





                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                      {this.state.veryMobile === false ?
                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <Image width={80} src={Retail} preview={false} /></div>
                          <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Retail')}</div>}
                            description={L('Manage employee scheduling, track purchasing, inventory, and more. Utilize our native PayPal integration for processing payments online and in-store.')} />

                          </div></div></div>
                        :
                        <div>
                          <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Retail')}</div>}
                            description={L('Manage employee scheduling, track purchasing, inventory, and more. Utilize our native PayPal integration for processing payments online and in-store.')} />

                        </div>
                      }
                    </Card>


                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                      {this.state.veryMobile === false ?
                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <Image width={80} src={Healthcare} preview={false} /></div>
                          <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Healthcare')}</div>}
                            description={L('Handle large-scale document processing, information storage, patient scheduling, and communication.')} />

                          </div></div></div>
                        :
                        <div>
                          <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Retail')}</div>}
                            description={L('Handle large-scale document processing, information storage, patient scheduling, and communication.')} />

                        </div>
                      }
                    </Card>


                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                      {this.state.veryMobile === false ?
                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <Image width={80} src={Legal} preview={false} /></div>
                          <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Insurance & Legal')}</div>}
                            description={L('Create document workflows that include collaboration, approvals, and reduce time wasted by continuously entering redundant information.')} />

                          </div></div></div>
                        :
                        <div>
                          <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Insurance & Legal')}</div>}
                            description={L('Create document workflows that include collaboration, approvals, and reduce time wasted by continuously entering redundant information.')} />

                        </div>
                      }
                    </Card>


                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                      {this.state.veryMobile === false ?
                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <Image width={80} src={FieldServices} preview={false} /></div>
                          <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Field Services')}</div>}
                            description={L('Manage job scheduling, techniciations in the field, and include customers in approvals, file management, and end-to-end projects.')} />

                          </div></div></div>
                        :
                        <div>
                          <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Field Services')}</div>}
                            description={L('Manage job scheduling, techniciations in the field, and include customers in approvals, file management, and end-to-end projects.')} />

                        </div>
                      }
                    </Card>


                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                      {this.state.veryMobile === false ?
                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <Image width={80} src={IT} preview={false} /></div>
                          <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('I.T. & Security')}</div>}
                            description={L('Remain compliant with change workflows, incident ticketing, asset lifecycle management.')} />

                          </div></div></div>
                        :
                        <div>
                          <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('I.T. & Security')}</div>}
                            description={L('Remain compliant with change workflows, incident ticketing, asset lifecycle management.')} />

                        </div>
                      }
                    </Card>


                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                      {this.state.veryMobile === false ?
                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <Image width={80} src={Property} preview={false} /></div>
                          <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Property Management')}</div>}
                            description={L('Handle multiple properties, tenant, service ticketing, and common tasks as a property owner.')} />

                          </div></div></div>
                        :
                        <div>
                          <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Property Management')}</div>}
                            description={L('Handle multiple properties, tenant, service ticketing, and common tasks as a property owner.')} />

                        </div>
                      }
                    </Card>


                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                      {this.state.veryMobile === false ?
                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <Image width={80} src={Warehousing} preview={false} /></div>
                          <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Manufacturing & 3PL')}</div>}
                            description={L('Manage purchasing, warehousing, sales, and distribution of products and skip the spreadsheets.')} />

                          </div></div></div>
                        :
                        <div>
                          <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Manufacturing & 3PL')}</div>}
                            description={L('Manage purchasing, warehousing, sales, and distribution of products and skip the spreadsheets.')} />

                        </div>
                      }
                    </Card>

                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                      {this.state.veryMobile === false ?
                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <Image width={80} src={Education} preview={false} /></div>
                          <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Education')}</div>}
                            description={L('Schedule, manage teachers/students, plan curriculum, and connect everyone on a single platform.')} />

                          </div></div></div>
                        :
                        <div>
                          <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Education')}</div>}
                            description={L('Schedule, manage teachers/students, plan curriculum, and connect everyone on a single platform.')} />

                        </div>
                      }
                    </Card>


                  </Card>

                </Drawer>
                :
                <Modal
                  closable={this.state.isMobile}
                  visible={this.state.sort_DrawerVisible}
                  cancelText={L('Cancel')}
                  footer={null}
                  width={730}
                  onCancel={() => this.setState({ sort_DrawerVisible: false })}
                  title={null}>
                  <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                    {L('Common Industries')}
                  </Divider>
                  <Row style={{ marginBottom: '0px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.primaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </Row>


                  <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>

                    <Card hoverable={true} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                      style={{}}><div style={{ float: 'left', marginRight: '5px' }}>
                        <Image src={Templates} preview={false} /></div>
                      <div>


                        <Meta className="font-face-gm"
                          title={<div style={{ fontSize: '1.1em', height: '25px', }}>{L('Built for Multiple Verticles')}</div>}
                          description={L('Swilab has been designed to meet the requirements of different business types. The ability to easily customize for your industry means you can get going quickly in the following areas and more!')} />
                      </div>
                    </Card>


                    <br />

                    <Card hoverable={true} cover={
                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <Image width={125} src={Fleet} preview={false} />
                      </div>
                      <div>
                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Transportation'}</div>}
                          description={'Manage fleets, and connect your staff, customers, and dispatch all in one place.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={
                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <Image width={125} src={Retail} preview={false} />
                      </div>
                      <div>
                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Retail'}</div>}
                          description={'Manage employee scheduling, track purchasing, inventory, and more. Utilize our native PayPal integration for processing payments online and in-store.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={
                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <Image width={125} src={Healthcare} preview={false} />
                      </div>
                      <div>
                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Healthcare'}</div>}
                          description={'Handle large-scale document processing, information storage, patient scheduling, and communication.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={
                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <Image width={125} src={Legal} preview={false} />
                      </div>
                      <div>
                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Insurance & Legal'}</div>}
                          description={'Create document workflows that include collaboration, approvals, and reduce time wasted by continuously entering redundant information.'} />
                      </div>


                    </Card>
                    <br />

                    <Card hoverable={true} cover={
                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <Image width={125} src={FieldServices} preview={false} />
                      </div>
                      <div>
                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Field Services'}</div>}
                          description={'Manage job scheduling, techniciations in the field, and include customers in approvals, file management, and end-to-end projects.'} />
                      </div>


                    </Card>


                    <br />

                    <Card hoverable={true} cover={
                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <Image width={125} src={IT} preview={false} />
                      </div>
                      <div>
                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'I.T. & Security'}</div>}
                          description={'Remain compliant with change workflows, incident ticketing, asset lifecycle management.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={
                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <Image width={125} src={Property} preview={false} />
                      </div>
                      <div>
                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Property Management'}</div>}
                          description={'Handle multiple properties, tenant, service ticketing, and common tasks as a property owner.'} />
                      </div>


                    </Card>


                    <br />

                    <Card hoverable={true} cover={
                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <Image width={125} src={Warehousing} preview={false} />
                      </div>
                      <div>
                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Manufacturing & 3PL'}</div>}
                          description={'Manage purchasing, warehousing, sales, and distribution of products and skip the spreadsheets.'} />
                      </div>


                    </Card>


                    <br />

                    <Card hoverable={true} cover={
                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <Image width={125} src={Education} preview={false} />
                      </div>
                      <div>
                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Education'}</div>}
                          description={'Schedule, manage teachers/students, plan curriculum, and connect everyone on a single platform.'} />
                      </div>


                    </Card>


                  </Card>


                </Modal>
              }

            </div>

            <div>
              {this.state.isMobile === true ?

                <Drawer
                  closable={this.state.isMobile === true ? true : false}
                  onClose={() => this.setState({ explore_DrawerVisible: false })}
                  visible={this.state.explore_DrawerVisible}
                  footer={null}
                  width={this.state.isMobile === true ? (window.innerWidth * 0.9) : 420}
                  title={null}  >
                  <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2em', marginBottom: '0px' }} >
                    {L('Unify Departments')}
                  </Divider>
                  <Row style={{ marginBottom: '20px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.primaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </Row>


                  <Image src={ReportView} style={{ margin: 'auto' }} preview={false} />


                  <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>
                    <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                      style={{}}>
                      <Meta className="font-face-gm"
                        title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Connect in one System'}</div>}
                        description={L('Swilab allows your organization to ditch multiple different systems and integrations. This means you can easily train staff, manage information, and work together in a single place.')} />

                    </Card>





                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                      {this.state.veryMobile === false ?
                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <FundTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Sales & Marketting')}</div>}
                            description={L('Ditch the traditional CRM & combine the lead sourcing, sales cycle, and customer management/communication into one place and seamlessly work together.')} />

                          </div></div></div>
                        :
                        <div>
                          <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Sales & Marketting')}</div>}
                            description={L('Ditch the traditional CRM & combine the lead sourcing, sales cycle, and customer management/communication into one place and seamlessly work together.')} />

                        </div>
                      }
                    </Card>

                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                      {this.state.veryMobile === false ?
                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <SmileTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Human Resources')}</div>}
                            description={L('Manage employee sourcing, onboarding, scheduling, and more in the same place as everything else and eliminate duplicate systems.')} />

                          </div></div></div>
                        :
                        <div>
                          <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Human Resources')}</div>}
                            description={L('Manage employee sourcing, onboarding, scheduling, and more in the same place as everything else and eliminate duplicate systems.')} />

                        </div>
                      }
                    </Card>

                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                      {this.state.veryMobile === false ?
                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <DashboardTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Inventory & Operations')}</div>}
                            description={L('From purchase to the receipt, scanning, processing, logistics, and sales - manage product and service lifecycles from start to finish.')} />

                          </div></div></div>
                        :
                        <div>
                          <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Inventory & Operations')}</div>}
                            description={L('From purchase to the receipt, scanning, processing, logistics, and sales - manage product and service lifecycles from start to finish.')} />

                        </div>
                      }
                    </Card>

                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                      {this.state.veryMobile === false ?
                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <DatabaseTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('I.T. & Support')}</div>}
                            description={L('Coordinate Change Management, Service ticketing, asset tracking, and more alongside each other business operation.')} />

                          </div></div></div>
                        :
                        <div>
                          <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('I.T. & Support')}</div>}
                            description={L('Coordinate Change Management, Service ticketing, asset tracking, and more alongside each other business operation.')} />

                        </div>
                      }
                    </Card>

                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                      {this.state.veryMobile === false ?
                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <AccountBookTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Accounting & Finance')}</div>}
                            description={L('Create and manage purchases, invoices, and accounting processes that allow a company-wide view of financials.')} />

                          </div></div></div>
                        :
                        <div>
                          <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Accounting & Finance')}</div>}
                            description={L('Create and manage purchases, invoices, and accounting processes that allow a company-wide view of financials.')} />

                        </div>
                      }
                    </Card>

                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                      {this.state.veryMobile === false ?
                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <CarTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Fleet & Field Services')}</div>}
                            description={L('Manage assets and technicians in the field by providing a mobile interface to all company services.')} />

                          </div></div></div>
                        :
                        <div>
                          <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Fleet & Field Services')}</div>}
                            description={L('Manage assets and technicians in the field by providing a mobile interface to all company services.')} />

                        </div>
                      }
                    </Card>

                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                      {this.state.veryMobile === false ?
                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>

                            <RocketTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Management')}</div>}
                            description={L('View real-time data via dashboard and custom reports in order to guide management and stay audit-ready.')} />
                          </div></div></div>
                        :
                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Management')}</div>}
                            description={L('View real-time data via dashboard and custom reports in order to guide management and stay audit-ready.')} />

                        </div>
                      }
                    </Card>

                  </Card>

                </Drawer>
                :
                <Modal
                  closable={this.state.isMobile}
                  visible={this.state.explore_DrawerVisible}
                  cancelText={L('Cancel')}
                  footer={null}
                  width={730}
                  onCancel={() => this.setState({ explore_DrawerVisible: false })}
                  title={null}>
                  <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                    {L('Unify Across Departments')}
                  </Divider>
                  <Row style={{ marginBottom: '0px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.primaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </Row>


                  <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>

                    <Card hoverable={true} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                      style={{}}><div style={{ float: 'left', marginRight: '5px' }}>
                        <Image src={ReportView} preview={false} /></div>
                      <div>


                        <Meta className="font-face-gm"
                          title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Connect in one System'}</div>}
                          description={L('Swilab allows your organization to ditch multiple different systems and integrations. This means you can easily train staff, manage information, and work together in a single place.')} />
                      </div>
                    </Card>


                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <FundTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Sales & Marketting'}</div>}
                          description={'Ditch the traditional CRM & combine the lead sourcing, sales cycle, and customer management/communication into one place and seamlessly work together.'} />
                      </div>


                    </Card>


                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <SmileTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Human Resources'}</div>}
                          description={'Manage employee sourcing, onboarding, scheduling, and more in the same place as everything else and eliminate duplicate systems.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <DashboardTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Inventory & Operations'}</div>}
                          description={'From purchase to the receipt, scanning, processing, logistics, and sales - manage product and service lifecycles from start to finish.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <DatabaseTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'I.T. & Support'}</div>}
                          description={'Coordinate Change Management, Service ticketing, asset tracking, and more alongside each other business operation.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <PieChartTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Supply Chain & Purchasing'}</div>}
                          description={'Connect with customers and vendors in order to track supply chain in real time, and ensure accurate pricing, service agreements, and more.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <AccountBookTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Accounting & Finance'}</div>}
                          description={'Create and manage purchases, invoices, and accounting processes that allow a company-wide view of financials.'} />
                      </div>


                    </Card>




                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <CarTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Fleet & Field Services'}</div>}
                          description={'Manage assets and technicians in the field by providing a mobile interface to all company services.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <RocketTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Management'}</div>}
                          description={'View real-time data via dashboard and custom reports in order to guide management and stay audit-ready.'} />
                      </div>


                    </Card>


                  </Card>


                </Modal>
              }

            </div>

            <div>
              {this.state.isMobile === true ?

                <Drawer
                  closable={this.state.isMobile === true ? true : false}
                  onClose={() => this.setState({ learn_DrawerVisible: false })}
                  visible={this.state.learn_DrawerVisible}
                  footer={null}
                  width={this.state.isMobile === true ? (window.innerWidth * 0.9) : 420}
                  title={null}  >
                  <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2em', marginBottom: '0px' }} >
                    {L('Build Your Brand')}
                  </Divider>
                  <Row style={{ marginBottom: '20px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.primaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </Row>


                  <Image src={Tenants} style={{ margin: 'auto' }} preview={false} />


                  <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>
                    <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                      style={{}}>
                      <Meta className="font-face-gm"
                        title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Unique Custom Features'}</div>}
                        description={L('Swilab offers many features often reserved for large scale companies, and makes them easy to use for anyone.')} />

                    </Card>


                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                      <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>


                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <AppstoreTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} /></div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Orgs & Multi-Tenancy'}</div>}
                                description={'Create multiple instances of all features within their own full-featured environment.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Orgs & Multi-Tenancy'}</div>}
                            description={'Create multiple instances of all features within their own full-featured environment.'} />
                        </div>
                      }
                    </Card>


                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                      <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>


                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <ControlTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} /></div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Dashboards'}</div>}
                                description={'View multiple unique and interactive dashboard cards, reports, and advanced editors for all data throughout Swilab.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Dashboards'}</div>}
                            description={'View multiple unique and interactive dashboard cards, reports, and advanced editors for all data throughout Swilab.'} />
                        </div>
                      }
                    </Card>

                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                      <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>


                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <AudioTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} /></div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Languages'}</div>}
                                description={'Configuration based U.I. to allow new languages to be added/updated to the 7 languages currently available.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Languages'}</div>}
                            description={'Configuration based U.I. to allow new languages to be added/updated to the 7 languages currently available.'} />
                        </div>
                      }
                    </Card>

                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                      <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>


                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <FlagTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} /></div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Themes'}</div>}
                                description={'Easily create a branded environment with org-specific logos and color schemes.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Themes'}</div>}
                            description={'Easily create a branded environment with org-specific logos and color schemes.'} />
                        </div>
                      }
                    </Card>


                    <br />
                    <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                      <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>


                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <LayoutTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} /></div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Web Portals'}</div>}
                                description={'Create org-specific websites to display information, capture customer data, and provide a login portal for internal and external users.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Web Portals'}</div>}
                            description={'Create org-specific websites to display information, capture customer data, and provide a login portal for internal and external users.'} />
                        </div>
                      }
                    </Card>




                  </Card>

                </Drawer>
                :
                <Modal
                  closable={this.state.isMobile}
                  visible={this.state.learn_DrawerVisible}
                  cancelText={L('Cancel')}
                  footer={null}
                  width={730}
                  onCancel={() => this.setState({ learn_DrawerVisible: false })}
                  title={null}>
                  <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                    {L('Build Your Brand')}
                  </Divider>
                  <Row style={{ marginBottom: '0px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.primaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </Row>


                  <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>

                    <Card hoverable={true} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                      style={{}}><div style={{ float: 'left', marginRight: '5px' }}>
                        <Image src={Tenants} preview={false} /></div>
                      <div>


                        <Meta className="font-face-gm"
                          title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Unique Custom Features'}</div>}
                          description={L('Swilab offers many features often reserved for large scale companies, and makes them easy to use for anyone.')} />
                      </div>
                    </Card>


                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <AppstoreTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Orgs & Multi-Tenancy'}</div>}
                          description={'Create multiple instances of all features within their own full-featured environment.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <ControlTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Dashboards'}</div>}
                          description={'View multiple unique and interactive dashboard cards, reports, and advanced editors for all data throughout Swilab.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <AudioTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Languages'}</div>}
                          description={'Configuration based U.I. to allow new languages to be added/updated to the 7 languages currently available.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <FlagTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Themes'}</div>}
                          description={'Easily create a branded environment with org-specific logos and color schemes.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <LayoutTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Web Portals'}</div>}
                          description={'Create org-specific websites to display information, capture customer data, and provide a login portal for internal and external users.'} />
                      </div>


                    </Card>


                  </Card>


                </Modal>
              }

            </div>

            <div>
              {this.state.isMobile === true ?

                <Drawer
                  closable={this.state.isMobile === true ? true : false}
                  onClose={() => this.setState({ discover_DrawerVisible: false })}
                  visible={this.state.discover_DrawerVisible}
                  footer={null}
                  width={this.state.isMobile === true ? (window.innerWidth * 0.9) : 420}
                  title={null}  >
                  <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2em', marginBottom: '0px' }} >
                    {L('Primary Feature List')}
                  </Divider>
                  <Row style={{ marginBottom: '20px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.primaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </Row>


                  <Image src={OpenItems} style={{ margin: 'auto' }} preview={false} />


                  <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>
                    <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                      style={{}}>
                      <Meta className="font-face-gm"
                        title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'End-to-End'}</div>}
                        description={L('By combining unique features not often included in the same package, such as languages, tenancy, and customer portals, Swilab is tailored to reach new markets.')} />

                    </Card>

                    <br />


                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>
                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <ContactsTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Personas'}</div>}
                                description={'Group Users into one or more categories in order to dynamic relationships, responsibilities, approvals, assignments, and more - without redefining any workflows or rules when users are added or removed.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Personas'}</div>}
                            description={'Group Users into one or more categories in order to dynamic relationships, responsibilities, approvals, assignments, and more - without redefining any workflows or rules when users are added or removed.'} />
                        </div>
                      }
                    </Card>



                    <br />


                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>
                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <BuildTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Teams'}</div>}
                                description={'Group Personas into larger teams or companies for managing relationships on a higher level.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Teams'}</div>}
                            description={'Group Personas into larger teams or companies for managing relationships on a higher level.'} />
                        </div>
                      }
                    </Card>


                    <br />


                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>
                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <TagsTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Inventory'}</div>}
                                description={'Manage products and assets with real-time scanning, automations, and direct relationships with all other categories.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Inventory'}</div>}
                            description={'Manage products and assets with real-time scanning, automations, and direct relationships with all other categories.'} />
                        </div>
                      }
                    </Card>

                    <br />


                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>
                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <ReconciliationTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Service Management'}</div>}
                                description={'Manage multiple processes that require employee and/or customer workflows, actions, and approvals.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Service Management'}</div>}
                            description={'Manage multiple processes that require employee and/or customer workflows, actions, and approvals.'} />
                        </div>
                      }
                    </Card>



                    <br />




                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>
                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <ScheduleTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Scheduling'}</div>}
                                description={'Create dynamic schedules that can be related to other categories and operations such as employee schedules, service agreements, and more.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Scheduling'}</div>}
                            description={'Create dynamic schedules that can be related to other categories and operations such as employee schedules, service agreements, and more.'} />
                        </div>
                      }
                    </Card>



                    <br />


                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>
                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <MessageTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Communication'}</div>}
                                description={'Create programs and templates for internal, email, & SMS notifications or campaigns.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Communication'}</div>}
                            description={'Create programs and templates for internal, email, & SMS notifications or campaigns.'} />
                        </div>
                      }
                    </Card>


                    <br />


                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>
                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <FileTextTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Doc Management'}</div>}
                                description={'Create, revise, approve, release, and retire documents using Swilabs native editor.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Doc Management'}</div>}
                            description={'Create, revise, approve, release, and retire documents using Swilabs native editor.'} />
                        </div>
                      }
                    </Card>


                    <br />


                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>
                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <ProjectTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Reporting'}</div>}
                                description={'Create workflows behind the creation, distribution, and retirement of reports.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Reporting'}</div>}
                            description={'Create workflows behind the creation, distribution, and retirement of reports.'} />
                        </div>
                      }
                    </Card>


                    <br />


                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>
                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <DollarTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Payments'}</div>}
                                description={'Create and integrate workflows across categories for payment process via native PayPal integration for Credit/Debit, PayPal, and Venmo payments.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Payments'}</div>}
                            description={'Create and integrate workflows across categories for payment process via native PayPal integration for Credit/Debit, PayPal, and Venmo payments.'} />
                        </div>
                      }
                    </Card>


                    <br />


                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>
                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <IdcardTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'User Management'}</div>}
                                description={'Create & manage platform users on a detailed and technical level.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'User Management'}</div>}
                            description={'Create & manage platform users on a detailed and technical level.'} />
                        </div>
                      }
                    </Card>

                    <br />


                    <Card cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{}}>
                      {this.state.veryMobile === false ?

                        <div>
                          <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                            <LockTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                          </div>
                          <div>

                            <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                              <Meta className="font-face-gm" style={{}}
                                title={<div style={{ fontSize: '1em', height: '20px', }}>{'Role Management'}</div>}
                                description={'Create permission profiles that can be assigned to  Users. Users can have multiple Roles. Roles determine visibility & ability to access Swilab categories.'} />

                            </div>

                          </div>
                        </div>
                        :

                        <div>
                          <Meta className="font-face-gm" style={{}}
                            title={<div style={{ fontSize: '1em', height: '20px', }}>{'Role Management'}</div>}
                            description={'Create permission profiles that can be assigned to  Users. Users can have multiple Roles. Roles determine visibility & ability to access Swilab categories.'} />
                        </div>
                      }
                    </Card>






                  </Card>

                </Drawer>
                :
                <Modal
                  closable={this.state.isMobile}
                  visible={this.state.discover_DrawerVisible}
                  cancelText={L('Cancel')}
                  footer={null}
                  width={730}
                  onCancel={() => this.setState({ discover_DrawerVisible: false })}
                  title={null}>
                  <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                    {L('Primary Feature List')}
                  </Divider>
                  <Row style={{ marginBottom: '0px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.primaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </Row>


                  <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>

                    <Card hoverable={true} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                      style={{}}><div style={{ float: 'left', marginRight: '5px' }}>
                        <Image src={OpenItems} preview={false} /></div>
                      <div>


                        <Meta className="font-face-gm"
                          title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'End-to-End'}</div>}
                          description={L('By combining unique features not often included in the same package, such as languages, tenancy, and customer portals, Swilab is tailored to reach new markets.')} />
                      </div>
                    </Card>





                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <ContactsTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Personas'}</div>}
                          description={'Group Users into one or more categories in order to dynamic relationships, responsibilities, approvals, assignments, and more - without redefining any workflows or rules when users are added or removed.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <BuildTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Teams'}</div>}
                          description={'Group Personas into larger teams or companies for managing relationships on a higher level. '} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <TagsTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Inventory'}</div>}
                          description={'Manage products and assets with real-time scanning, automations, and direct relationships with all other categories.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <ReconciliationTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Service Management'}</div>}
                          description={'Manage multiple processes that require employee and/or customer workflows, actions, and approvals. '} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <ScheduleTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Scheduling'}</div>}
                          description={'Create dynamic schedules that can be related to other categories and operations such as employee schedules, service agreements, and more.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <MessageTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Communication'}</div>}
                          description={'Create programs and templates for internal, email, & SMS notifications or campaigns. '} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <FileTextTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Doc Management'}</div>}
                          description={'Create, revise, approve, release, and retire documents using Swilabs native editor.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <ProjectTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Reporting'}</div>}
                          description={'Create workflows behind the creation, distribution, and retirement of reports.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <DollarTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Payments'}</div>}
                          description={'Create and integrate workflows across categories for payment process via native PayPal integration for Credit/Debit, PayPal, and Venmo payments. '} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <IdcardTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'User Management'}</div>}
                          description={'Create & manage platform users on a detailed and technical level.'} />
                      </div>


                    </Card>

                    <br />

                    <Card hoverable={true} cover={

                      <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                      </div>
                    } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                      style={{ height: '125px' }}>
                      <div style={{ float: 'left', marginRight: '12px' }}>
                        <LockTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                      </div>
                      <div>

                        <Meta className="font-face-gm" style={{ width: '75%' }}
                          title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Role Management'}</div>}
                          description={'Create permission profiles that can be assigned to  Users. Users can have multiple Roles. Roles determine visibility & ability to access Swilab categories. '} />
                      </div>


                    </Card>



                  </Card>


                </Modal>
              }

            </div>

            <div>
              {this.state.isMobile === true ?

                <Drawer
                  closable={this.state.isMobile === true ? true : false}
                  onClose={() => this.setState({ video_DrawerVisible: false })}
                  visible={this.state.video_DrawerVisible}
                  footer={null}
                  width={this.state.isMobile === true ? (window.innerWidth * 0.9) : 420}
                  title={null}  >
                  <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2em', marginBottom: '0px' }} >
                    {L('IDEM Global + Swilab')}
                  </Divider>
                  <Row style={{ marginBottom: '20px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.primaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </Row>




                  <Player fluid={true} poster={VideoCover}>
                    <source
                      src={'https://files.swilab.com/PoweredBySwilab.mp4'}
                      type="video/mp4"
                    />
                    <ControlBar autoHide={false} className="playApp" />
                  </Player>




                </Drawer>
                :
                <Modal
                  closable={this.state.isMobile}
                  visible={this.state.video_DrawerVisible}
                  cancelText={L('Cancel')}
                  footer={null}
                  width={730}
                  onCancel={() => this.setState({ video_DrawerVisible: false })}
                  title={null}>
                  <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                    {L('IDEM Global + Swilab')}
                  </Divider>
                  <Row style={{ marginBottom: '0px' }}>
                    <Progress
                      strokeColor={{
                        from: this.state.secondaryTenantColor,
                        to: this.state.primaryTenantColor,
                      }}
                      showInfo={false}
                      percent={100}
                      status="normal"
                      size={'small'}
                    />
                  </Row>


                  <Player fluid={true} poster={VideoCover}>
                    <source
                      src={'https://files.swilab.com/PoweredBySwilab.mp4'}
                      type="video/mp4"
                    />
                    <ControlBar autoHide={false} className="playApp" />
                  </Player>


                </Modal>
              }

            </div>

          </div>

          : this.state.loading === false ?

            <div className="font-face-gm">

              <div>
                <Card bordered={false}>
                  <div>


                    <Form>
                      <div style={{ margin: 'auto', maxWidth: '900px' }}>

                        <div style={{ margin: 'auto', maxWidth: '890px' }} >
                          {this.state.windowWidth >= 550 ?
                            (

                              <div>


                                <div>

                                  <Image src={Titlw} preview={false} />

                                  <div>

                                    {this.state.softMenu === true ?
                                      (<div>
                                        <div style={{
                                          float: 'right', position: 'fixed',
                                          top: 10, right: 25, zIndex: 99,
                                        }}>

                                          <Button
                                            disabled={this.state.loading}
                                            className="font-face-gm" onClick={() => window.scrollTo({ top: 10, behavior: "smooth" })}
                                            style={{ minWidth: '75px', height: '27px', fontSize: '0.8em', backgroundColor: 'transparent' }}
                                            type="default">
                                            <UpCircleOutlined />{L('Top')}
                                          </Button>


                                        </div>

                                      </div>) :

                                      <div>

                                        <div style={{ float: 'right', position: 'fixed', top: 10, right: 25, zIndex: 100, }}>
                                          <Button disabled={this.state.loading}
                                            // onClick={() => this.setState({ team_modalVisible: true })}
                                            className="font-face-gm" style={{
                                              minWidth: '85px', height: '30px',
                                              fontSize: '1em',
                                            }} type="dashed">
                                            {L('Accessability')}
                                          </Button>
                                        </div>



                                        <div style={{ float: 'right', position: 'fixed', top: 10, right: 149, zIndex: 99, }}>

                                          <Button disabled={this.state.loading}
                                            onClick={() => this.setState({ login_modalVisible: true })}
                                            className="font-face-gm" style={{
                                              minWidth: '85px', height: '30px', fontSize: '1em',
                                              background: this.state.secondaryTenantColor, borderColor: this.state.secondaryTenantColor
                                            }}
                                            type="primary">
                                            {L('Login')}
                                          </Button>

                                        </div>

                                        <div style={{ float: 'right', position: 'fixed', top: 10, right: 243, zIndex: 101, }}>

                                          <Button disabled={this.state.loading}
                                            onClick={() => this.setState({ contact_modalVisible: true })}
                                            className="font-face-gm" style={{
                                              minWidth: '85px', height: '30px',
                                              fontSize: '1em', backgroundColor: 'transparent'
                                            }} type="default">
                                            {L('Contact')}
                                          </Button>

                                        </div>

                                      </div>}

                                  </div>


                                </div>

                              </div>
                            ) : (

                              <div>


                                <div style={{ height: '10px', margin: 'auto', textAlign: 'center' }}></div>

                                <Image src={Titlw} preview={false} />


                                <div>

                                  {this.state.softMenu === true ?
                                    (<div>
                                      <div style={{
                                        float: 'right', position: 'fixed',
                                        top: 10, right: 25, zIndex: 99,
                                      }}>

                                        <Button
                                          disabled={this.state.loading}
                                          className="font-face-gm" onClick={() => window.scrollTo({ top: 10, behavior: "smooth" })}
                                          style={{ minWidth: '75px', height: '27px', fontSize: '0.8em', backgroundColor: 'transparent' }}
                                          type="default">
                                          <UpCircleOutlined />{L('Top')}
                                        </Button>


                                      </div>

                                    </div>) :


                                    <div>

                                      <div style={{ float: 'right', position: 'fixed', top: 10, right: 25, zIndex: 99, }}>
                                        <Button
                                          disabled={this.state.loading}
                                          onClick={() => this.setState({ login_modalVisible: true })}
                                          className="font-face-gm" style={{ minWidth: '75px', height: '30px', fontSize: '1em', backgroundColor: 'transparent' }} type="default">
                                          {L('Login')}
                                        </Button>
                                      </div>
                                      <div style={{ float: 'right', position: 'fixed', top: 45, right: 25, zIndex: 99, }}>

                                        <Button disabled={this.state.loading}
                                          onClick={() => this.setState({ contact_modalVisible: true })}
                                          className="font-face-gm" style={{ width: '75px', height: '30px', fontSize: '0.85em', backgroundColor: 'transparent' }} type="default">
                                          {L('Contact')}
                                        </Button>

                                      </div>
                                    </div>}

                                </div>


                              </div>
                            )}

                        </div>


                      </div>
                    </Form>




                    <br />
                    <div style={{ margin: 'auto', marginTop: '-15px', maxWidth: '900px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.secondaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </div>

                    <br />
                    <div style={{ margin: 'auto', marginTop: '-15px', maxWidth: '900px' }}>

                      <DashboardView
                        primaryColor={this.state.primaryTenantColor}
                        secondaryColor={this.state.secondaryTenantColor}
                        dashboardDto={dashboardLayoutFTB}
                      />
                    </div>

                  </div>

                  <div>

                    <LoginForm
                      authenticationStore={this.props.authenticationStore}
                      location={this.props.location}
                      visible={this.state.login_modalVisible}
                      primaryColor={this.state.primaryTenantColor}
                      secondaryColor={this.state.secondaryTenantColor}
                      isMobile={this.state.isMobile}
                      onCancel={() => this.setState({
                        login_modalVisible: false,
                      })}
                      onLogin={() => this.setState({
                        login_modalVisible: false,
                      })}
                    />


                    <OurTeam
                      location={this.props.location}
                      visible={this.state.team_modalVisible}
                      primaryColor={this.state.primaryTenantColor}
                      secondaryColor={this.state.secondaryTenantColor}
                      isMobile={this.state.isMobile}
                      onCancel={() => this.setState({
                        team_modalVisible: false,
                      })}
                      onLogin={() => this.setState({
                        team_modalVisible: false,
                      })}
                    />

                    <OurStory
                      location={this.props.location}
                      visible={this.state.ourStory_ModalVisible}
                      primaryColor={this.state.primaryTenantColor}
                      secondaryColor={this.state.secondaryTenantColor}
                      isMobile={this.state.isMobile}
                      onCancel={() => this.setState({
                        ourStory_ModalVisible: false,
                      })}
                      onLogin={() => this.setState({
                        ourStory_ModalVisible: false,
                      })}
                    />

                    <ContactForm
                      formRef={this.contact_FormRef}
                      authenticationStore={this.props.authenticationStore}
                      location={this.props.location}
                      visible={this.state.contact_modalVisible}
                      primaryColor={this.state.primaryTenantColor}
                      secondaryColor={this.state.secondaryTenantColor}
                      isMobile={this.state.isMobile}
                      onCancel={this.demoContact_handleCancel}
                      onLogin={this.contact_handleUpdate}
                    />

                    <ScheduleDemoForm
                      formRef={this.demo_FormRef}
                      authenticationStore={this.props.authenticationStore}
                      location={this.props.location}
                      visible={this.state.demo_modalVisible}
                      primaryColor={this.state.primaryTenantColor}
                      secondaryColor={this.state.secondaryTenantColor}
                      isMobile={this.state.isMobile}
                      onCancel={this.demoContact_handleCancel}
                      onLogin={this.demo_handleUpdate}
                    />

                  </div>

                </Card>

                <div style={{ margin: 'auto', maxWidth: '900px', marginBottom: '20px', width: '100%' }}>

                  <div style={{ height: '150px', margin: 'auto', textAlign: 'center' }}>
                    <br />


                    <Form className="" >
                      <Row style={{ marginTop: '0% ', textAlign: 'center' }}>

                        <Col className="font-face-gm" style={{ fontSize: '1em' }} span={22} offset={1}>


                          <Button className="font-face-gm"
                            onClick={() => this.legal_createOrUpdateModalOpen({ id: 0 })}
                            shape="round" size="small" type="link" style={{ color: '#433f36', fontSize: '20px' }} >
                            {L('Legal')}
                          </Button>|

                          <Button className="font-face-gm"
                            onClick={() => window.open('https://www.linkedin.com/company/swilab/', "_blank")}
                            shape="round" size="small" type="link" style={{ color: '#433f36', fontSize: '20px' }} >
                            {L('Social')}
                          </Button>


                        </Col>

                      </Row>
                      <Row style={{ marginTop: '0% ', textAlign: 'center' }}>

                        <Col className="font-face-gm" style={{ fontSize: '0.9em' }} span={22} offset={1}>
                          {L('Copyright - Swilab, LLC - 2023 - All Rights Reserved.')}
                        </Col>

                      </Row>
                    </Form>

                  </div>

                </div>

              </div>

              <MoreInfoDrawer
                visible={this.state.moreInfo_drawerVisible}
                primaryColor={this.state.primaryTenantColor}
                secondaryColor={this.state.secondaryTenantColor}
                onCancel={() => this.setState({ moreInfo_drawerVisible: false })}
                infoType={this.state.moreInfoType}
              />

              <LegalForm
                visible={this.state.legal_modalVisible}
                primaryColor={this.state.primaryTenantColor}
                secondaryColor={this.state.secondaryTenantColor}
                isMobile={this.state.isMobile}
                onCancel={() => this.setState({ legal_modalVisible: false })} />


              <div>

                {this.state.isMobile === true ?

                  <Drawer
                    closable={this.state.isMobile === true ? true : false}
                    onClose={() => this.setState({ empower_DrawerVisible: false })}
                    visible={this.state.empower_DrawerVisible}
                    footer={null}
                    width={this.state.isMobile === true ? (window.innerWidth * 0.9) : 420}
                    title={null}  >
                    <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2em', marginBottom: '0px' }} >
                      {L('Business Operations')}
                    </Divider>
                    <Row style={{ marginBottom: '20px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.primaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </Row>


                    <Image src={EmpowerImage} style={{ margin: 'auto' }} preview={false} />


                    <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>
                      <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                        style={{}}>
                        <Meta className="font-face-gm"
                          title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Workflow and Automation'}</div>}
                          description={L('Swilab offers a simple way to manage custom workflows, approvals, and automations needed to successfully manage operations from anywhere.')} />

                      </Card>





                      <br />


                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>


                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <Image width={80} src={InOffice} preview={false} /></div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'In the Office'}</div>}
                                  description={'Get a handle on day-to-day tasks and plan for future business with robust desktop features.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'In the Office'}</div>}
                              description={'Get a handle on day-to-day tasks and plan for future business with robust desktop features.'} />
                          </div>
                        }
                      </Card>


                      <br />
                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>
                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <Image width={80} src={InField} preview={false} /></div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'In the Field'}</div>}
                                  description={'Work from anywhere with intuitive mobile design for tablets and phones. All desktop features are supported by mobile devices.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'In the Field'}</div>}
                              description={'Work from anywhere with intuitive mobile design for tablets and phones. All desktop features are supported by mobile devices.'} />
                          </div>
                        }

                      </Card>





                    </Card>

                  </Drawer>
                  :
                  <Modal
                    closable={this.state.isMobile}
                    visible={this.state.empower_DrawerVisible}
                    cancelText={L('Cancel')}
                    footer={null}
                    width={730}
                    onCancel={() => this.setState({ empower_DrawerVisible: false })}
                    title={null}>
                    <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                      {L('Business Operations')}
                    </Divider>
                    <Row style={{ marginBottom: '0px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.primaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </Row>


                    <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>

                      <Card hoverable={true} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                        style={{}}><div style={{ float: 'left', marginRight: '5px' }}>
                          <Image src={EmpowerImage} preview={false} /></div>
                        <div>


                          <Meta className="font-face-gm"
                            title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Workflow and Automation'}</div>}
                            description={L('Swilab offers a simple way to manage custom workflows, approvals, and automations needed to successfully manage operations from anywhere.')} />
                        </div>
                      </Card>


                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <Image width={125} src={InOffice} preview={false} />

                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'In the Office'}</div>}
                            description={'Get a handle on day-to-day tasks and plan for future business with robust desktop features.'} />
                        </div>


                      </Card>

                      <br />
                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <Image width={125} src={InField} preview={false} />

                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'In the Field'}</div>}
                            description={'Work from anywhere with intuitive mobile design for tablets and phones. All desktop features are supported by mobile devices.'} />
                        </div>


                      </Card>



                    </Card>


                  </Modal>
                }

              </div>

              <div>
                {this.state.isMobile === true ?

                  <Drawer
                    closable={this.state.isMobile === true ? true : false}
                    onClose={() => this.setState({ engage_DrawerVisible: false })}
                    visible={this.state.engage_DrawerVisible}
                    footer={null}
                    width={this.state.isMobile === true ? (window.innerWidth * 0.9) : 420}
                    title={null}  >
                    <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2em', marginBottom: '0px' }} >
                      {L('More than CRM')}
                    </Divider>
                    <Row style={{ marginBottom: '20px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.primaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </Row>


                    <Image src={PeoplePeview} style={{ margin: 'auto' }} preview={false} />


                    <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>
                      <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                        style={{}}>
                        <Meta className="font-face-gm"
                          title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'a Powerful Engine'}</div>}
                          description={L('Swilab is a robust platform capable of advanced operations, and built to enable future growth/improvements by a standardized corporate development team.')} />

                      </Card>





                      <br />


                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>


                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <Image width={80} src={Vendors} preview={false} /></div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Customer Portals'}</div>}
                                  description={'Design beautiful customer portals to display information, capture customer data, and provide customer login portals.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Customer Portals'}</div>}
                              description={'Design beautiful customer portals to display information, capture customer data, and provide customer login portals.'} />
                          </div>
                        }
                      </Card>


                      <br />
                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>
                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <Image width={80} src={Portals} preview={false} /></div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Vendor Management'}</div>}
                                  description={'Manage supply chain internally, and engage external vendors by providing access to information just like employees and customers via web portal.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Vendor Management'}</div>}
                              description={'Manage supply chain internally, and engage external vendors by providing access to information just like employees and customers via web portal.'} />
                          </div>
                        }

                      </Card>





                    </Card>

                  </Drawer>
                  :
                  <Modal
                    closable={this.state.isMobile}
                    visible={this.state.engage_DrawerVisible}
                    cancelText={L('Cancel')}
                    footer={null}
                    width={730}
                    onCancel={() => this.setState({ engage_DrawerVisible: false })}
                    title={null}>
                    <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                      {L('More than CRM')}
                    </Divider>
                    <Row style={{ marginBottom: '0px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.primaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </Row>


                    <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>

                      <Card hoverable={true} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                        style={{}}><div style={{ float: 'left', marginRight: '5px' }}>
                          <Image src={PeoplePeview} preview={false} /></div>
                        <div>


                          <Meta className="font-face-gm"
                            title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'a POwerful Engine'}</div>}
                            description={L('Swilab is a robust platform capable of advanced operations, and built to enable future growth/improvements by a standardized corporate development team.')} />
                        </div>
                      </Card>


                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <Image width={125} src={Vendors} preview={false} />

                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Customer Portals'}</div>}
                            description={'Design beautiful customer portals to display information, capture customer data, and provide customer login portals.'} />
                        </div>


                      </Card>

                      <br />
                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <Image width={125} src={Portals} preview={false} />

                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Vendor Management'}</div>}
                            description={'Manage supply chain internally, and engage external vendors by providing access to information just like employees and customers via web portal'} />
                        </div>


                      </Card>


                    </Card>


                  </Modal>
                }

              </div>

              <div>
                {this.state.isMobile === true ?

                  <Drawer
                    closable={this.state.isMobile === true ? true : false}
                    onClose={() => this.setState({ inform_DrawerVisible: false })}
                    visible={this.state.inform_DrawerVisible}
                    footer={null}
                    width={this.state.isMobile === true ? (window.innerWidth * 0.9) : 420}
                    title={null}  >
                    <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2em', marginBottom: '0px' }} >
                      {L('Real-Time Data')}
                    </Divider>
                    <Row style={{ marginBottom: '20px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.primaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </Row>


                    <Image src={Dashboards} style={{ margin: 'auto' }} preview={false} />


                    <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>
                      <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                        style={{}}>
                        <Meta className="font-face-gm"
                          title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Intuitive Design'}</div>}
                          description={L('Cutting-Edge design practices allow traditionally technical and complex activities to be performed simply, and promote adoption even by less technical customers/staff.')} />

                      </Card>





                      <br />


                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>


                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <Image width={80} src={HRChart} preview={false} /></div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Leadership Dashboards'}</div>}
                                  description={'Company access for up to 10 attendees to all Quarterly meetings, seminars, and social networking events.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Audit-Ready Reports'}</div>}
                              description={'Company access for up to 10 attendees to all Quarterly meetings, seminars, and social networking events.'} />
                          </div>
                        }
                      </Card>


                      <br />
                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>
                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <Image width={80} src={Audit} preview={false} /></div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'In the Field '}</div>}
                                  description={'Company access for up to 10 attendees to all Quarterly meetings, seminars, and social networking events.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'In the Field '}</div>}
                              description={'Company access for up to 10 attendees to all Quarterly meetings, seminars, and social networking events.'} />
                          </div>
                        }

                      </Card>





                    </Card>

                  </Drawer>
                  :
                  <Modal
                    closable={this.state.isMobile}
                    visible={this.state.inform_DrawerVisible}
                    cancelText={L('Cancel')}
                    footer={null}
                    width={730}
                    onCancel={() => this.setState({ inform_DrawerVisible: false })}
                    title={null}>
                    <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                      {L('Real-Time Data')}
                    </Divider>
                    <Row style={{ marginBottom: '0px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.primaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </Row>


                    <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>

                      <Card hoverable={true} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                        style={{}}><div style={{ float: 'left', marginRight: '5px' }}>
                          <Image src={Dashboards} preview={false} /></div>
                        <div>


                          <Meta className="font-face-gm"
                            title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Intuitive Design'}</div>}
                            description={L('Cutting-Edge design practices allow traditionally technical and complex activities to be performed simply, and promote adoption even by less technical customers/staff.')} />
                        </div>
                      </Card>


                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <Image width={125} src={HRChart} preview={false} />

                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Leadership Dashboards'}</div>}
                            description={'Company access for up to 10 attendees to all Quarterly meetings, seminars, and social networking events.'} />
                        </div>


                      </Card>

                      <br />
                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />



                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <Image width={125} src={Audit} preview={false} />

                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Audit-Ready Reports'}</div>}
                            description={'Company access for up to 10 attendees to all Quarterly meetings, seminars, and social networking events.'} />
                        </div>


                      </Card>



                    </Card>


                  </Modal>
                }

              </div>

              <div>
                {this.state.isMobile === true ?

                  <Drawer
                    closable={this.state.isMobile === true ? true : false}
                    onClose={() => this.setState({ sort_DrawerVisible: false })}
                    visible={this.state.sort_DrawerVisible}
                    footer={null}
                    width={this.state.isMobile === true ? (window.innerWidth * 0.9) : 420}
                    title={null}  >
                    <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2em', marginBottom: '0px' }} >
                      {L('Common Industries')}
                    </Divider>
                    <Row style={{ marginBottom: '20px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.primaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </Row>


                    <Image src={Templates} style={{ margin: 'auto' }} preview={false} />


                    <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>
                      <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                        style={{}}>
                        <Meta className="font-face-gm"
                          title={<div style={{ fontSize: '1.1em', height: '25px', }}>{L('Built for Multiple Verticles')}</div>}
                          description={L('Swilab has been designed to meet the requirements of different business types. The ability to easily customize for your industry means you can get going quickly in the following areas and more!')} />

                      </Card>









                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                        {this.state.veryMobile === false ?
                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <Image width={80} src={Fleet} preview={false} /></div>
                            <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Transportation')}</div>}
                              description={L('Manage fleets, and connect your staff, customers, and dispatch all in one place.')} />

                            </div></div></div>
                          :
                          <div>
                            <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Transportation')}</div>}
                              description={L('Manage fleets, and connect your staff, customers, and dispatch all in one place.')} />
                          </div>
                        }
                      </Card>





                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                        {this.state.veryMobile === false ?
                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <Image width={80} src={Retail} preview={false} /></div>
                            <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Retail')}</div>}
                              description={L('Manage employee scheduling, track purchasing, inventory, and more. Utilize our native PayPal integration for processing payments online and in-store.')} />

                            </div></div></div>
                          :
                          <div>
                            <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Retail')}</div>}
                              description={L('Manage employee scheduling, track purchasing, inventory, and more. Utilize our native PayPal integration for processing payments online and in-store.')} />

                          </div>
                        }
                      </Card>


                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                        {this.state.veryMobile === false ?
                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <Image width={80} src={Healthcare} preview={false} /></div>
                            <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Healthcare')}</div>}
                              description={L('Handle large-scale document processing, information storage, patient scheduling, and communication.')} />

                            </div></div></div>
                          :
                          <div>
                            <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Retail')}</div>}
                              description={L('Handle large-scale document processing, information storage, patient scheduling, and communication.')} />

                          </div>
                        }
                      </Card>


                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                        {this.state.veryMobile === false ?
                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <Image width={80} src={Legal} preview={false} /></div>
                            <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Insurance & Legal')}</div>}
                              description={L('Create document workflows that include collaboration, approvals, and reduce time wasted by continuously entering redundant information.')} />

                            </div></div></div>
                          :
                          <div>
                            <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Insurance & Legal')}</div>}
                              description={L('Create document workflows that include collaboration, approvals, and reduce time wasted by continuously entering redundant information.')} />

                          </div>
                        }
                      </Card>


                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                        {this.state.veryMobile === false ?
                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <Image width={80} src={FieldServices} preview={false} /></div>
                            <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Field Services')}</div>}
                              description={L('Manage job scheduling, techniciations in the field, and include customers in approvals, file management, and end-to-end projects.')} />

                            </div></div></div>
                          :
                          <div>
                            <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Field Services')}</div>}
                              description={L('Manage job scheduling, techniciations in the field, and include customers in approvals, file management, and end-to-end projects.')} />

                          </div>
                        }
                      </Card>


                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                        {this.state.veryMobile === false ?
                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <Image width={80} src={IT} preview={false} /></div>
                            <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('I.T. & Security')}</div>}
                              description={L('Remain compliant with change workflows, incident ticketing, asset lifecycle management.')} />

                            </div></div></div>
                          :
                          <div>
                            <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('I.T. & Security')}</div>}
                              description={L('Remain compliant with change workflows, incident ticketing, asset lifecycle management.')} />

                          </div>
                        }
                      </Card>


                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                        {this.state.veryMobile === false ?
                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <Image width={80} src={Property} preview={false} /></div>
                            <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Property Management')}</div>}
                              description={L('Handle multiple properties, tenant, service ticketing, and common tasks as a property owner.')} />

                            </div></div></div>
                          :
                          <div>
                            <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Property Management')}</div>}
                              description={L('Handle multiple properties, tenant, service ticketing, and common tasks as a property owner.')} />

                          </div>
                        }
                      </Card>


                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                        {this.state.veryMobile === false ?
                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <Image width={80} src={Warehousing} preview={false} /></div>
                            <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Manufacturing & 3PL')}</div>}
                              description={L('Manage purchasing, warehousing, sales, and distribution of products and skip the spreadsheets.')} />

                            </div></div></div>
                          :
                          <div>
                            <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Manufacturing & 3PL')}</div>}
                              description={L('Manage purchasing, warehousing, sales, and distribution of products and skip the spreadsheets.')} />

                          </div>
                        }
                      </Card>

                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                        {this.state.veryMobile === false ?
                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <Image width={80} src={Education} preview={false} /></div>
                            <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Education')}</div>}
                              description={L('Schedule, manage teachers/students, plan curriculum, and connect everyone on a single platform.')} />

                            </div></div></div>
                          :
                          <div>
                            <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Education')}</div>}
                              description={L('Schedule, manage teachers/students, plan curriculum, and connect everyone on a single platform.')} />

                          </div>
                        }
                      </Card>


                    </Card>

                  </Drawer>
                  :
                  <Modal
                    closable={this.state.isMobile}
                    visible={this.state.sort_DrawerVisible}
                    cancelText={L('Cancel')}
                    footer={null}
                    width={730}
                    onCancel={() => this.setState({ sort_DrawerVisible: false })}
                    title={null}>
                    <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                      {L('Common Industries')}
                    </Divider>
                    <Row style={{ marginBottom: '0px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.primaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </Row>


                    <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>

                      <Card hoverable={true} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                        style={{}}><div style={{ float: 'left', marginRight: '5px' }}>
                          <Image src={Templates} preview={false} /></div>
                        <div>


                          <Meta className="font-face-gm"
                            title={<div style={{ fontSize: '1.1em', height: '25px', }}>{L('Built for Multiple Verticles')}</div>}
                            description={L('Swilab has been designed to meet the requirements of different business types. The ability to easily customize for your industry means you can get going quickly in the following areas and more!')} />
                        </div>
                      </Card>


                      <br />

                      <Card hoverable={true} cover={
                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <Image width={125} src={Fleet} preview={false} />
                        </div>
                        <div>
                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Transportation'}</div>}
                            description={'Manage fleets, and connect your staff, customers, and dispatch all in one place.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={
                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <Image width={125} src={Retail} preview={false} />
                        </div>
                        <div>
                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Retail'}</div>}
                            description={'Manage employee scheduling, track purchasing, inventory, and more. Utilize our native PayPal integration for processing payments online and in-store.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={
                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <Image width={125} src={Healthcare} preview={false} />
                        </div>
                        <div>
                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Healthcare'}</div>}
                            description={'Handle large-scale document processing, information storage, patient scheduling, and communication.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={
                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <Image width={125} src={Legal} preview={false} />
                        </div>
                        <div>
                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Insurance & Legal'}</div>}
                            description={'Create document workflows that include collaboration, approvals, and reduce time wasted by continuously entering redundant information.'} />
                        </div>


                      </Card>
                      <br />

                      <Card hoverable={true} cover={
                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <Image width={125} src={FieldServices} preview={false} />
                        </div>
                        <div>
                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Field Services'}</div>}
                            description={'Manage job scheduling, techniciations in the field, and include customers in approvals, file management, and end-to-end projects.'} />
                        </div>


                      </Card>


                      <br />

                      <Card hoverable={true} cover={
                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <Image width={125} src={IT} preview={false} />
                        </div>
                        <div>
                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'I.T. & Security'}</div>}
                            description={'Remain compliant with change workflows, incident ticketing, asset lifecycle management.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={
                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <Image width={125} src={Property} preview={false} />
                        </div>
                        <div>
                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Property Management'}</div>}
                            description={'Handle multiple properties, tenant, service ticketing, and common tasks as a property owner.'} />
                        </div>


                      </Card>


                      <br />

                      <Card hoverable={true} cover={
                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <Image width={125} src={Warehousing} preview={false} />
                        </div>
                        <div>
                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Manufacturing & 3PL'}</div>}
                            description={'Manage purchasing, warehousing, sales, and distribution of products and skip the spreadsheets.'} />
                        </div>


                      </Card>


                      <br />

                      <Card hoverable={true} cover={
                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />  </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <Image width={125} src={Education} preview={false} />
                        </div>
                        <div>
                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Education'}</div>}
                            description={'Schedule, manage teachers/students, plan curriculum, and connect everyone on a single platform.'} />
                        </div>


                      </Card>


                    </Card>


                  </Modal>
                }

              </div>

              <div>
                {this.state.isMobile === true ?

                  <Drawer
                    closable={this.state.isMobile === true ? true : false}
                    onClose={() => this.setState({ explore_DrawerVisible: false })}
                    visible={this.state.explore_DrawerVisible}
                    footer={null}
                    width={this.state.isMobile === true ? (window.innerWidth * 0.9) : 420}
                    title={null}  >
                    <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2em', marginBottom: '0px' }} >
                      {L('Unify Departments')}
                    </Divider>
                    <Row style={{ marginBottom: '20px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.primaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </Row>


                    <Image src={ReportView} style={{ margin: 'auto' }} preview={false} />


                    <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>
                      <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                        style={{}}>
                        <Meta className="font-face-gm"
                          title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Connect in one System'}</div>}
                          description={L('Swilab allows your organization to ditch multiple different systems and integrations. This means you can easily train staff, manage information, and work together in a single place.')} />

                      </Card>





                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                        {this.state.veryMobile === false ?
                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <FundTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Sales & Marketting')}</div>}
                              description={L('Ditch the traditional CRM & combine the lead sourcing, sales cycle, and customer management/communication into one place and seamlessly work together.')} />

                            </div></div></div>
                          :
                          <div>
                            <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Sales & Marketting')}</div>}
                              description={L('Ditch the traditional CRM & combine the lead sourcing, sales cycle, and customer management/communication into one place and seamlessly work together.')} />

                          </div>
                        }
                      </Card>

                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                        {this.state.veryMobile === false ?
                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <SmileTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Human Resources')}</div>}
                              description={L('Manage employee sourcing, onboarding, scheduling, and more in the same place as everything else and eliminate duplicate systems.')} />

                            </div></div></div>
                          :
                          <div>
                            <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Human Resources')}</div>}
                              description={L('Manage employee sourcing, onboarding, scheduling, and more in the same place as everything else and eliminate duplicate systems.')} />

                          </div>
                        }
                      </Card>

                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                        {this.state.veryMobile === false ?
                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <DashboardTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Inventory & Operations')}</div>}
                              description={L('From purchase to the receipt, scanning, processing, logistics, and sales - manage product and service lifecycles from start to finish.')} />

                            </div></div></div>
                          :
                          <div>
                            <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Inventory & Operations')}</div>}
                              description={L('From purchase to the receipt, scanning, processing, logistics, and sales - manage product and service lifecycles from start to finish.')} />

                          </div>
                        }
                      </Card>

                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                        {this.state.veryMobile === false ?
                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <DatabaseTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('I.T. & Support')}</div>}
                              description={L('Coordinate Change Management, Service ticketing, asset tracking, and more alongside each other business operation.')} />

                            </div></div></div>
                          :
                          <div>
                            <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('I.T. & Support')}</div>}
                              description={L('Coordinate Change Management, Service ticketing, asset tracking, and more alongside each other business operation.')} />

                          </div>
                        }
                      </Card>

                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                        {this.state.veryMobile === false ?
                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <AccountBookTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Accounting & Finance')}</div>}
                              description={L('Create and manage purchases, invoices, and accounting processes that allow a company-wide view of financials.')} />

                            </div></div></div>
                          :
                          <div>
                            <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Accounting & Finance')}</div>}
                              description={L('Create and manage purchases, invoices, and accounting processes that allow a company-wide view of financials.')} />

                          </div>
                        }
                      </Card>

                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                        {this.state.veryMobile === false ?
                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <CarTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Fleet & Field Services')}</div>}
                              description={L('Manage assets and technicians in the field by providing a mobile interface to all company services.')} />

                            </div></div></div>
                          :
                          <div>
                            <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Fleet & Field Services')}</div>}
                              description={L('Manage assets and technicians in the field by providing a mobile interface to all company services.')} />

                          </div>
                        }
                      </Card>

                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}> <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>

                        {this.state.veryMobile === false ?
                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>

                              <RocketTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div><div style={{ marginRight: '5px', width: '75%', float: 'left' }}>  <Meta className="font-face-gm" style={{}}

                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Management')}</div>}
                              description={L('View real-time data via dashboard and custom reports in order to guide management and stay audit-ready.')} />
                            </div></div></div>
                          :
                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{L('Management')}</div>}
                              description={L('View real-time data via dashboard and custom reports in order to guide management and stay audit-ready.')} />

                          </div>
                        }
                      </Card>

                    </Card>

                  </Drawer>
                  :
                  <Modal
                    closable={this.state.isMobile}
                    visible={this.state.explore_DrawerVisible}
                    cancelText={L('Cancel')}
                    footer={null}
                    width={730}
                    onCancel={() => this.setState({ explore_DrawerVisible: false })}
                    title={null}>
                    <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                      {L('Unify Across Departments')}
                    </Divider>
                    <Row style={{ marginBottom: '0px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.primaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </Row>


                    <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>

                      <Card hoverable={true} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                        style={{}}><div style={{ float: 'left', marginRight: '5px' }}>
                          <Image src={ReportView} preview={false} /></div>
                        <div>


                          <Meta className="font-face-gm"
                            title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Connect in one System'}</div>}
                            description={L('Swilab allows your organization to ditch multiple different systems and integrations. This means you can easily train staff, manage information, and work together in a single place.')} />
                        </div>
                      </Card>


                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <FundTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Sales & Marketting'}</div>}
                            description={'Ditch the traditional CRM & combine the lead sourcing, sales cycle, and customer management/communication into one place and seamlessly work together.'} />
                        </div>


                      </Card>


                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <SmileTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Human Resources'}</div>}
                            description={'Manage employee sourcing, onboarding, scheduling, and more in the same place as everything else and eliminate duplicate systems.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <DashboardTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Inventory & Operations'}</div>}
                            description={'From purchase to the receipt, scanning, processing, logistics, and sales - manage product and service lifecycles from start to finish.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <DatabaseTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'I.T. & Support'}</div>}
                            description={'Coordinate Change Management, Service ticketing, asset tracking, and more alongside each other business operation.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <PieChartTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Supply Chain & Purchasing'}</div>}
                            description={'Connect with customers and vendors in order to track supply chain in real time, and ensure accurate pricing, service agreements, and more.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <AccountBookTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Accounting & Finance'}</div>}
                            description={'Create and manage purchases, invoices, and accounting processes that allow a company-wide view of financials.'} />
                        </div>


                      </Card>




                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <CarTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Fleet & Field Services'}</div>}
                            description={'Manage assets and technicians in the field by providing a mobile interface to all company services.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <RocketTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Management'}</div>}
                            description={'View real-time data via dashboard and custom reports in order to guide management and stay audit-ready.'} />
                        </div>


                      </Card>


                    </Card>


                  </Modal>
                }

              </div>

              <div>
                {this.state.isMobile === true ?

                  <Drawer
                    closable={this.state.isMobile === true ? true : false}
                    onClose={() => this.setState({ learn_DrawerVisible: false })}
                    visible={this.state.learn_DrawerVisible}
                    footer={null}
                    width={this.state.isMobile === true ? (window.innerWidth * 0.9) : 420}
                    title={null}  >
                    <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2em', marginBottom: '0px' }} >
                      {L('Build Your Brand')}
                    </Divider>
                    <Row style={{ marginBottom: '20px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.primaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </Row>


                    <Image src={Tenants} style={{ margin: 'auto' }} preview={false} />


                    <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>
                      <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                        style={{}}>
                        <Meta className="font-face-gm"
                          title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Unique Custom Features'}</div>}
                          description={L('Swilab offers many features often reserved for large scale companies, and makes them easy to use for anyone.')} />

                      </Card>


                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>


                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <AppstoreTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} /></div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Orgs & Multi-Tenancy'}</div>}
                                  description={'Create multiple instances of all features within their own full-featured environment.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Orgs & Multi-Tenancy'}</div>}
                              description={'Create multiple instances of all features within their own full-featured environment.'} />
                          </div>
                        }
                      </Card>


                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>


                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <ControlTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} /></div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Dashboards'}</div>}
                                  description={'View multiple unique and interactive dashboard cards, reports, and advanced editors for all data throughout Swilab.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Dashboards'}</div>}
                              description={'View multiple unique and interactive dashboard cards, reports, and advanced editors for all data throughout Swilab.'} />
                          </div>
                        }
                      </Card>

                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>


                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <AudioTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} /></div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Languages'}</div>}
                                  description={'Configuration based U.I. to allow new languages to be added/updated to the 7 languages currently available.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Languages'}</div>}
                              description={'Configuration based U.I. to allow new languages to be added/updated to the 7 languages currently available.'} />
                          </div>
                        }
                      </Card>

                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>


                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <FlagTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} /></div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Themes'}</div>}
                                  description={'Easily create a branded environment with org-specific logos and color schemes.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Themes'}</div>}
                              description={'Easily create a branded environment with org-specific logos and color schemes.'} />
                          </div>
                        }
                      </Card>


                      <br />
                      <Card cover={<div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                        <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }} style={{}}>


                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <LayoutTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} /></div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Web Portals'}</div>}
                                  description={'Create org-specific websites to display information, capture customer data, and provide a login portal for internal and external users.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Web Portals'}</div>}
                              description={'Create org-specific websites to display information, capture customer data, and provide a login portal for internal and external users.'} />
                          </div>
                        }
                      </Card>




                    </Card>

                  </Drawer>
                  :
                  <Modal
                    closable={this.state.isMobile}
                    visible={this.state.learn_DrawerVisible}
                    cancelText={L('Cancel')}
                    footer={null}
                    width={730}
                    onCancel={() => this.setState({ learn_DrawerVisible: false })}
                    title={null}>
                    <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                      {L('Build Your Brand')}
                    </Divider>
                    <Row style={{ marginBottom: '0px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.primaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </Row>


                    <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>

                      <Card hoverable={true} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                        style={{}}><div style={{ float: 'left', marginRight: '5px' }}>
                          <Image src={Tenants} preview={false} /></div>
                        <div>


                          <Meta className="font-face-gm"
                            title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Unique Custom Features'}</div>}
                            description={L('Swilab offers many features often reserved for large scale companies, and makes them easy to use for anyone.')} />
                        </div>
                      </Card>


                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <AppstoreTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Orgs & Multi-Tenancy'}</div>}
                            description={'Create multiple instances of all features within their own full-featured environment.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <ControlTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Dashboards'}</div>}
                            description={'View multiple unique and interactive dashboard cards, reports, and advanced editors for all data throughout Swilab.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <AudioTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Languages'}</div>}
                            description={'Configuration based U.I. to allow new languages to be added/updated to the 7 languages currently available.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <FlagTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Themes'}</div>}
                            description={'Easily create a branded environment with org-specific logos and color schemes.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <LayoutTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Web Portals'}</div>}
                            description={'Create org-specific websites to display information, capture customer data, and provide a login portal for internal and external users.'} />
                        </div>


                      </Card>


                    </Card>


                  </Modal>
                }

              </div>

              <div>
                {this.state.isMobile === true ?

                  <Drawer
                    closable={this.state.isMobile === true ? true : false}
                    onClose={() => this.setState({ discover_DrawerVisible: false })}
                    visible={this.state.discover_DrawerVisible}
                    footer={null}
                    width={this.state.isMobile === true ? (window.innerWidth * 0.9) : 420}
                    title={null}  >
                    <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2em', marginBottom: '0px' }} >
                      {L('Primary Feature List')}
                    </Divider>
                    <Row style={{ marginBottom: '20px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.primaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </Row>


                    <Image src={OpenItems} style={{ margin: 'auto' }} preview={false} />


                    <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>
                      <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                        style={{}}>
                        <Meta className="font-face-gm"
                          title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'End-to-End'}</div>}
                          description={L('By combining unique features not often included in the same package, such as languages, tenancy, and customer portals, Swilab is tailored to reach new markets.')} />

                      </Card>

                      <br />


                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>
                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <ContactsTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Personas'}</div>}
                                  description={'Group Users into one or more categories in order to dynamic relationships, responsibilities, approvals, assignments, and more - without redefining any workflows or rules when users are added or removed.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Personas'}</div>}
                              description={'Group Users into one or more categories in order to dynamic relationships, responsibilities, approvals, assignments, and more - without redefining any workflows or rules when users are added or removed.'} />
                          </div>
                        }
                      </Card>



                      <br />


                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>
                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <BuildTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Teams'}</div>}
                                  description={'Group Personas into larger teams or companies for managing relationships on a higher level.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Teams'}</div>}
                              description={'Group Personas into larger teams or companies for managing relationships on a higher level.'} />
                          </div>
                        }
                      </Card>


                      <br />


                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>
                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <TagsTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Inventory'}</div>}
                                  description={'Manage products and assets with real-time scanning, automations, and direct relationships with all other categories.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Inventory'}</div>}
                              description={'Manage products and assets with real-time scanning, automations, and direct relationships with all other categories.'} />
                          </div>
                        }
                      </Card>

                      <br />


                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>
                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <ReconciliationTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Service Management'}</div>}
                                  description={'Manage multiple processes that require employee and/or customer workflows, actions, and approvals.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Service Management'}</div>}
                              description={'Manage multiple processes that require employee and/or customer workflows, actions, and approvals.'} />
                          </div>
                        }
                      </Card>



                      <br />




                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>
                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <ScheduleTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Scheduling'}</div>}
                                  description={'Create dynamic schedules that can be related to other categories and operations such as employee schedules, service agreements, and more.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Scheduling'}</div>}
                              description={'Create dynamic schedules that can be related to other categories and operations such as employee schedules, service agreements, and more.'} />
                          </div>
                        }
                      </Card>



                      <br />


                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>
                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <MessageTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Communication'}</div>}
                                  description={'Create programs and templates for internal, email, & SMS notifications or campaigns.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Communication'}</div>}
                              description={'Create programs and templates for internal, email, & SMS notifications or campaigns.'} />
                          </div>
                        }
                      </Card>


                      <br />


                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>
                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <FileTextTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Doc Management'}</div>}
                                  description={'Create, revise, approve, release, and retire documents using Swilabs native editor.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Doc Management'}</div>}
                              description={'Create, revise, approve, release, and retire documents using Swilabs native editor.'} />
                          </div>
                        }
                      </Card>


                      <br />


                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>
                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <ProjectTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Reporting'}</div>}
                                  description={'Create workflows behind the creation, distribution, and retirement of reports.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Reporting'}</div>}
                              description={'Create workflows behind the creation, distribution, and retirement of reports.'} />
                          </div>
                        }
                      </Card>


                      <br />


                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>
                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <DollarTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Payments'}</div>}
                                  description={'Create and integrate workflows across categories for payment process via native PayPal integration for Credit/Debit, PayPal, and Venmo payments.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Payments'}</div>}
                              description={'Create and integrate workflows across categories for payment process via native PayPal integration for Credit/Debit, PayPal, and Venmo payments.'} />
                          </div>
                        }
                      </Card>


                      <br />


                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>
                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <IdcardTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'User Management'}</div>}
                                  description={'Create & manage platform users on a detailed and technical level.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'User Management'}</div>}
                              description={'Create & manage platform users on a detailed and technical level.'} />
                          </div>
                        }
                      </Card>

                      <br />


                      <Card cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{}}>
                        {this.state.veryMobile === false ?

                          <div>
                            <div style={{ marginRight: '10px', width: '20%', float: 'left' }}>
                              <LockTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                            </div>
                            <div>

                              <div style={{ marginRight: '5px', width: '75%', float: 'left' }}>
                                <Meta className="font-face-gm" style={{}}
                                  title={<div style={{ fontSize: '1em', height: '20px', }}>{'Role Management'}</div>}
                                  description={'Create permission profiles that can be assigned to  Users. Users can have multiple Roles. Roles determine visibility & ability to access Swilab categories.'} />

                              </div>

                            </div>
                          </div>
                          :

                          <div>
                            <Meta className="font-face-gm" style={{}}
                              title={<div style={{ fontSize: '1em', height: '20px', }}>{'Role Management'}</div>}
                              description={'Create permission profiles that can be assigned to  Users. Users can have multiple Roles. Roles determine visibility & ability to access Swilab categories.'} />
                          </div>
                        }
                      </Card>






                    </Card>

                  </Drawer>
                  :
                  <Modal
                    closable={this.state.isMobile}
                    visible={this.state.discover_DrawerVisible}
                    cancelText={L('Cancel')}
                    footer={null}
                    width={730}
                    onCancel={() => this.setState({ discover_DrawerVisible: false })}
                    title={null}>
                    <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                      {L('Primary Feature List')}
                    </Divider>
                    <Row style={{ marginBottom: '0px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.primaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </Row>


                    <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>

                      <Card hoverable={true} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                        style={{}}><div style={{ float: 'left', marginRight: '5px' }}>
                          <Image src={OpenItems} preview={false} /></div>
                        <div>


                          <Meta className="font-face-gm"
                            title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'End-to-End'}</div>}
                            description={L('By combining unique features not often included in the same package, such as languages, tenancy, and customer portals, Swilab is tailored to reach new markets.')} />
                        </div>
                      </Card>





                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <ContactsTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Personas'}</div>}
                            description={'Group Users into one or more categories in order to dynamic relationships, responsibilities, approvals, assignments, and more - without redefining any workflows or rules when users are added or removed.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <BuildTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Teams'}</div>}
                            description={'Group Personas into larger teams or companies for managing relationships on a higher level. '} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <TagsTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Inventory'}</div>}
                            description={'Manage products and assets with real-time scanning, automations, and direct relationships with all other categories.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <ReconciliationTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Service Management'}</div>}
                            description={'Manage multiple processes that require employee and/or customer workflows, actions, and approvals. '} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <ScheduleTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Scheduling'}</div>}
                            description={'Create dynamic schedules that can be related to other categories and operations such as employee schedules, service agreements, and more.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <MessageTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Communication'}</div>}
                            description={'Create programs and templates for internal, email, & SMS notifications or campaigns. '} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <FileTextTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Doc Management'}</div>}
                            description={'Create, revise, approve, release, and retire documents using Swilabs native editor.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <ProjectTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Reporting'}</div>}
                            description={'Create workflows behind the creation, distribution, and retirement of reports.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <DollarTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Payments'}</div>}
                            description={'Create and integrate workflows across categories for payment process via native PayPal integration for Credit/Debit, PayPal, and Venmo payments. '} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <IdcardTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'User Management'}</div>}
                            description={'Create & manage platform users on a detailed and technical level.'} />
                        </div>


                      </Card>

                      <br />

                      <Card hoverable={true} cover={

                        <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                          <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} />
                        </div>
                      } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}

                        style={{ height: '125px' }}>
                        <div style={{ float: 'left', marginRight: '12px' }}>
                          <LockTwoTone style={{ fontSize: '3em' }} twoToneColor={[this.state.primaryTenantColor, '#f1f2f5']} />
                        </div>
                        <div>

                          <Meta className="font-face-gm" style={{ width: '75%' }}
                            title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'Role Management'}</div>}
                            description={'Create permission profiles that can be assigned to  Users. Users can have multiple Roles. Roles determine visibility & ability to access Swilab categories. '} />
                        </div>


                      </Card>



                    </Card>


                  </Modal>
                }

              </div>

              <div>
                {this.state.isMobile === true ?

                  <Drawer
                    closable={this.state.isMobile === true ? true : false}
                    onClose={() => this.setState({ video_DrawerVisible: false })}
                    visible={this.state.video_DrawerVisible}
                    footer={null}
                    width={this.state.isMobile === true ? (window.innerWidth * 0.9) : 420}
                    title={null}  >
                    <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2em', marginBottom: '0px' }} >
                      {L('IDEM Global + Swilab')}
                    </Divider>
                    <Row style={{ marginBottom: '20px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.primaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </Row>




                    <Player fluid={true} poster={VideoCover}>
                      <source
                        src={'https://files.swilab.com/PoweredBySwilab.mp4'}
                        type="video/mp4"
                      />
                      <ControlBar autoHide={false} className="playApp" />
                    </Player>




                  </Drawer>
                  :
                  <Modal
                    closable={this.state.isMobile}
                    visible={this.state.video_DrawerVisible}
                    cancelText={L('Cancel')}
                    footer={null}
                    width={730}
                    onCancel={() => this.setState({ video_DrawerVisible: false })}
                    title={null}>
                    <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                      {L('IDEM Global + Swilab')}
                    </Divider>
                    <Row style={{ marginBottom: '0px' }}>
                      <Progress
                        strokeColor={{
                          from: this.state.secondaryTenantColor,
                          to: this.state.primaryTenantColor,
                        }}
                        showInfo={false}
                        percent={100}
                        status="normal"
                        size={'small'}
                      />
                    </Row>


                    <Player fluid={true} poster={VideoCover}>
                      <source
                        src={'https://files.swilab.com/PoweredBySwilab.mp4'}
                        type="video/mp4"
                      />
                      <ControlBar autoHide={false} className="playApp" />
                    </Player>


                  </Modal>
                }

              </div>

            </div>

            : null}


      </div>

    );

  }
}

export default Login;
